import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React, { createContext, useContext, useCallback, useReducer, useEffect, useMemo, useState } from 'react';
import Axios from 'axios';
import { encode } from 'base-64';
import { encode as encode$1 } from 'utf8';
import _typeof from '@babel/runtime/helpers/typeof';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';

var Category;

(function (Category) {
  Category["HMS_ARBEIDSMILJO"] = "HMS_ARBEIDSMILJO";
  Category["HMS"] = "HMS";
  Category["ARBEIDSTID_OG_LONN"] = "ARBEIDSTID_OG_LONN";
  Category["LEDER"] = "LEDER";
  Category["SAFETY_REPRESENTATIVE"] = "SAFETY_REPRESENTATIVE";
  Category["SYKEFRAVAER"] = "SYKEFRAVAER";
  Category["OPPSIGELSE_OG_NEDBEMANNING"] = "OPPSIGELSE_OG_NEDBEMANNING";
  Category["FERIE"] = "FERIE";
  Category["PERMITTERING_OG_PERMISJON"] = "PERMITTERING_OG_PERMISJON";
  Category["ANSETTELSE"] = "ANSETTELSE";
  Category["PERSONVERN"] = "PERSONVERN";
  Category["SYSTEMATISK_HMS_ARBEID"] = "SYSTEMATISK_HMS_ARBEID";
  Category["ARBEIDSHELSE"] = "ARBEIDSHELSE";
  Category["FYSISK_KJEMISK_OG_BIOLOGISK"] = "FYSISK_KJEMISK_OG_BIOLOGISK";
  Category["PSYKOSOSIALT"] = "PSYKOSOSIALT";
  Category["ERGONOMISK"] = "ERGONOMISK";
  Category["HR"] = "HR";
  Category["INTERNAL"] = "INTERNAL";
})(Category || (Category = {}));

// CourseCategory.ts
var CourseCategory; // CourseFagbankCategory.ts //NOTED: need to call option to prevent reexport issue from category

(function (CourseCategory) {
  CourseCategory["ERGONOMISK"] = "ERGONOMISK";
  CourseCategory["HMS"] = "HMS";
  CourseCategory["HR"] = "HR";
  CourseCategory["INTERNAL"] = "INTERNAL";
  CourseCategory["LEDER"] = "LEDER";
  CourseCategory["SAFETY_REPRESENTATIVE"] = "SAFETY_REPRESENTATIVE";
})(CourseCategory || (CourseCategory = {}));

var CourseFagbankCategory;

(function (CourseFagbankCategory) {
  CourseFagbankCategory["FERIE_OG_FRAVAR"] = "FERIE_OG_FRAVAR";
  CourseFagbankCategory["HMS_ARBEIDSMILJO"] = "HMS_ARBEIDSMILJO";
  CourseFagbankCategory["LEDERSTOTTE"] = "LEDERSTOTTE";
})(CourseFagbankCategory || (CourseFagbankCategory = {}));

var XpandProduct;

(function (XpandProduct) {
  XpandProduct["PRODUCT_1"] = "PRODUCT_1";
  XpandProduct["PRODUCT_2"] = "PRODUCT_2";
  XpandProduct["PRODUCT_3"] = "PRODUCT_3";
  XpandProduct["PRODUCT_4"] = "PRODUCT_4";
  XpandProduct["PRODUCT_5"] = "PRODUCT_5";
  XpandProduct["PRODUCT_8"] = "PRODUCT_8";
  XpandProduct["PRODUCT_9"] = "PRODUCT_9";
  XpandProduct["PRODUCT_99"] = "PRODUCT_99";
  XpandProduct["PRODUCT_GJI"] = "PRODUCT_GJI";
})(XpandProduct || (XpandProduct = {}));

var Language;

(function (Language) {
  Language["NORWEGIAN"] = "NORWEGIAN";
  Language["ENGLISH"] = "ENGLISH";
  Language["POLISH"] = "POLISH";
  Language["LITHUANIAN"] = "LITHUANIAN";
})(Language || (Language = {}));

var _COURSE_TYPES;
var CourseType;

(function (CourseType) {
  CourseType["ONSITE"] = "Onsite";
  CourseType["ONLINE"] = "Online";
  CourseType["BROADCAST"] = "OnlineBroadcasting";
})(CourseType || (CourseType = {}));

var COURSE_TYPES = (_COURSE_TYPES = {}, _defineProperty(_COURSE_TYPES, Language.ENGLISH, [{
  key: CourseType.ONSITE,
  value: CourseType.ONSITE,
  text: "Onsite"
}, {
  key: CourseType.ONLINE,
  value: CourseType.ONLINE,
  text: "Online"
}, {
  key: CourseType.BROADCAST,
  value: CourseType.BROADCAST,
  text: "Online Broadcasting"
}]), _defineProperty(_COURSE_TYPES, Language.NORWEGIAN, [{
  key: CourseType.ONSITE,
  value: CourseType.ONSITE,
  text: "Oppmøte"
}, {
  key: CourseType.ONLINE,
  value: CourseType.ONLINE,
  text: "Videokurs"
}, {
  key: CourseType.BROADCAST,
  value: CourseType.BROADCAST,
  text: "Direkte sendt"
}]), _defineProperty(_COURSE_TYPES, Language.POLISH, [{
  key: CourseType.ONSITE,
  value: CourseType.ONSITE,
  text: "Na miejscu"
}, {
  key: CourseType.ONLINE,
  value: CourseType.ONLINE,
  text: "Online"
}, {
  key: CourseType.BROADCAST,
  value: CourseType.BROADCAST,
  text: "Transmisja online"
}]), _defineProperty(_COURSE_TYPES, Language.LITHUANIAN, [{
  key: CourseType.ONSITE,
  value: CourseType.ONSITE,
  text: "Vieta"
}, {
  key: CourseType.ONLINE,
  value: CourseType.ONLINE,
  text: "Internetu"
}, {
  key: CourseType.BROADCAST,
  value: CourseType.BROADCAST,
  text: "Tiesioginė transliacija"
}]), _COURSE_TYPES);

var _DocumentType$SCHEMAS, _DocumentType$HSE_INS, _DocumentType$REPORTS, _DocumentType$REVISIO, _DocumentType$BHT_INF, _DocumentType$AGREEME, _DocumentType$OTHER, _DOCUMENT_TYPES_LANGU;
var DocumentType;

(function (DocumentType) {
  DocumentType["SCHEMAS"] = "SCHEMAS";
  DocumentType["HSE_INSPECTION"] = "HSE_INSPECTION";
  DocumentType["REPORTS"] = "REPORTS";
  DocumentType["REVISION"] = "REVISION";
  DocumentType["BHT_INFO"] = "BHT_INFO";
  DocumentType["AGREEMENT_PLANS"] = "AGREEMENT_PLANS";
  DocumentType["OTHER"] = "OTHER";
})(DocumentType || (DocumentType = {}));

var DOCUMENT_TYPES_LANGUAGE_MAP = (_DOCUMENT_TYPES_LANGU = {}, _defineProperty(_DOCUMENT_TYPES_LANGU, DocumentType.SCHEMAS, (_DocumentType$SCHEMAS = {}, _defineProperty(_DocumentType$SCHEMAS, Language.ENGLISH, "Forms"), _defineProperty(_DocumentType$SCHEMAS, Language.NORWEGIAN, "Kartleggingskjema"), _defineProperty(_DocumentType$SCHEMAS, Language.POLISH, "Formularze"), _defineProperty(_DocumentType$SCHEMAS, Language.LITHUANIAN, "Formos"), _DocumentType$SCHEMAS)), _defineProperty(_DOCUMENT_TYPES_LANGU, DocumentType.HSE_INSPECTION, (_DocumentType$HSE_INS = {}, _defineProperty(_DocumentType$HSE_INS, Language.ENGLISH, "Inspection"), _defineProperty(_DocumentType$HSE_INS, Language.NORWEGIAN, "Vernerunde"), _defineProperty(_DocumentType$HSE_INS, Language.POLISH, "Inspekcja BHP"), _defineProperty(_DocumentType$HSE_INS, Language.LITHUANIAN, "HSS apžiūra"), _DocumentType$HSE_INS)), _defineProperty(_DOCUMENT_TYPES_LANGU, DocumentType.REPORTS, (_DocumentType$REPORTS = {}, _defineProperty(_DocumentType$REPORTS, Language.ENGLISH, "Reports"), _defineProperty(_DocumentType$REPORTS, Language.NORWEGIAN, "Rapporter"), _defineProperty(_DocumentType$REPORTS, Language.POLISH, "Raporty"), _defineProperty(_DocumentType$REPORTS, Language.LITHUANIAN, "Ataskaitos"), _DocumentType$REPORTS)), _defineProperty(_DOCUMENT_TYPES_LANGU, DocumentType.REVISION, (_DocumentType$REVISIO = {}, _defineProperty(_DocumentType$REVISIO, Language.ENGLISH, "Revision"), _defineProperty(_DocumentType$REVISIO, Language.NORWEGIAN, "Revisjon"), _defineProperty(_DocumentType$REVISIO, Language.POLISH, "Rewizja"), _defineProperty(_DocumentType$REVISIO, Language.LITHUANIAN, "Peržiūra"), _DocumentType$REVISIO)), _defineProperty(_DOCUMENT_TYPES_LANGU, DocumentType.BHT_INFO, (_DocumentType$BHT_INF = {}, _defineProperty(_DocumentType$BHT_INF, Language.ENGLISH, "BHT information"), _defineProperty(_DocumentType$BHT_INF, Language.NORWEGIAN, "Bedriftshelsetjenesten informerer"), _defineProperty(_DocumentType$BHT_INF, Language.POLISH, "Informacje BHP"), _defineProperty(_DocumentType$BHT_INF, Language.LITHUANIAN, "BHT informacija"), _DocumentType$BHT_INF)), _defineProperty(_DOCUMENT_TYPES_LANGU, DocumentType.AGREEMENT_PLANS, (_DocumentType$AGREEME = {}, _defineProperty(_DocumentType$AGREEME, Language.ENGLISH, "Agreements and plans"), _defineProperty(_DocumentType$AGREEME, Language.NORWEGIAN, "Avtaler / plan for bistand"), _defineProperty(_DocumentType$AGREEME, Language.POLISH, "Umowy i plany"), _defineProperty(_DocumentType$AGREEME, Language.LITHUANIAN, "Sutartys ir planai"), _DocumentType$AGREEME)), _defineProperty(_DOCUMENT_TYPES_LANGU, DocumentType.OTHER, (_DocumentType$OTHER = {}, _defineProperty(_DocumentType$OTHER, Language.ENGLISH, "Other"), _defineProperty(_DocumentType$OTHER, Language.NORWEGIAN, "Annet"), _defineProperty(_DocumentType$OTHER, Language.POLISH, "Inne"), _defineProperty(_DocumentType$OTHER, Language.LITHUANIAN, "Kiti"), _DocumentType$OTHER)), _DOCUMENT_TYPES_LANGU);

var EventType;

(function (EventType) {
  EventType["Online"] = "Online";
  EventType["OnSite"] = "OnSite";
})(EventType || (EventType = {}));

var MediaType;

(function (MediaType) {
  MediaType["VIDEO"] = "VIDEO";
  MediaType["WEBINAR"] = "WEBINAR";
  MediaType["VIDEO_SERIES"] = "VIDEO_SERIES";
  MediaType["EPISODE"] = "EPISODE";
})(MediaType || (MediaType = {}));

var SubscriptionTypeEnum;

(function (SubscriptionTypeEnum) {
  SubscriptionTypeEnum["ENTERPRISE"] = "ENTERPRISE";
  SubscriptionTypeEnum["PERSONAL"] = "PERSONAL";
})(SubscriptionTypeEnum || (SubscriptionTypeEnum = {}));

var LanguageCode;

(function (LanguageCode) {
  LanguageCode["EN"] = "EN";
  LanguageCode["NO"] = "NO";
  LanguageCode["PL"] = "PL";
  LanguageCode["LT"] = "LT";
})(LanguageCode || (LanguageCode = {}));

var APIContext = createContext({});

/**
 * A hook for getting the globally configured Axios instance.
 */

var useHttp = function useHttp() {
  return useContext(APIContext).axiosInstance || Axios;
};

/**
 * A generic hook for making a DELETE request.
 * 
 *```
 * import {
 *  useDeleteAsync,
 *  useSingleStateReducer,
 *  Tag,
 * } from '@lyonfuture/api';
 * 
 * const [deleteAsync, cancelDelete] = useDeleteAsync<Tag>('tags');
 * const [tagsState, tagsDispatch] = useSingleStateReducer<Tag>();
 * 
 * useEffect(() => {
 *  deleteAsync(tagState.data.id, tagsDispatch);
 * 
 *  return () => {
 *    cancelDelete();
 *  };
 * }, []);
 * ```
 * 
 * @param path The API endpoint
 */
var useDeleteAsync = function useDeleteAsync(path) {
  var http = useHttp();
  var source = Axios.CancelToken.source();

  var deleteAsync = /*#__PURE__*/function () {
    var _deleteAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var subPath,
          config,
          dispatch,
          response,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              subPath = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
              config = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              dispatch = _args.length > 2 && _args[2] !== undefined ? _args[2] : function () {};
              subPath = subPath.trim();
              subPath = subPath && "/".concat(subPath);
              config = config === null ? {} : config;
              dispatch({
                type: 'deleting'
              });
              _context.prev = 7;
              // Set cancelToken for request cancellation
              config.cancelToken = source.token;
              _context.next = 11;
              return http["delete"]("".concat(path).concat(subPath), config);

            case 11:
              response = _context.sent;
              dispatch({
                type: 'delete-success',
                data: response.data
              });
              return _context.abrupt("return", response);

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](7);
              dispatch({
                type: 'delete-error',
                error: _context.t0
              });
              throw _context.t0;

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 16]]);
    }));

    function deleteAsync() {
      return _deleteAsync.apply(this, arguments);
    }

    return deleteAsync;
  }();

  var cancel = function cancel() {
    source.cancel();
  };

  return [deleteAsync, cancel];
};

/**
 * A generic hook for making a GET request.
 * 
 * ```
 * import {
 *  useGetAsync,
 *  useListStateReducer,
 *  Tag,
 * } from '@lyonfuture/api';
 * 
 * const [getAsync, cancelGet] = useGetAsync<Tag>('tags');
 * const [tagsState, tagsDispatch] = useListStateReducer<Tag>();
 * 
 * useEffect(() => {
 *  const config: AxiosRequestConfig = {};
 *  getAsync('', config, tagsDispatch);
 * 
 *  return () => {
 *    cancelGet();
 *  };
 * }, []);
 * ```
 * 
 * @param path The API endpoint
 */
var useGetAsync = function useGetAsync(path) {
  var http = useHttp();
  var source = Axios.CancelToken.source();

  var getAsync = /*#__PURE__*/function () {
    var _getAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var subPath,
          config,
          dispatch,
          response,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              subPath = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
              config = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              dispatch = _args.length > 2 && _args[2] !== undefined ? _args[2] : function () {};
              subPath = subPath.trim();
              subPath = subPath && "/".concat(subPath);
              config = config === null ? {} : config;
              dispatch({
                type: 'loading'
              });
              _context.prev = 7;
              // Set cancelToken for request cancellation
              config.cancelToken = source.token;
              _context.next = 11;
              return http.get("".concat(path).concat(subPath), config);

            case 11:
              response = _context.sent;
              dispatch({
                type: 'success',
                data: response.data
              });
              return _context.abrupt("return", response);

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](7);
              dispatch({
                type: 'error',
                error: _context.t0
              });
              throw _context.t0;

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 16]]);
    }));

    function getAsync() {
      return _getAsync.apply(this, arguments);
    }

    return getAsync;
  }();

  var cancel = function cancel() {
    source.cancel();
  };

  return [getAsync, cancel];
};

/**
 * A generic hook for making a HEAD request.
 * 
 * ```
 * import {
 *  useHeadAsync,
 *  useListStateReducer,
 *  Tag,
 * } from '@lyonfuture/api';
 * 
 * const [headAsync, cancelHead] = useHeadAsync<Tag>('tags');
 * const [tagsState, tagsDispatch] = useListStateReducer<Tag>();
 * 
 * useEffect(() => {
 *  const config: AxiosRequestConfig = {};
 *  headAsync('some-tag', config, tagsDispatch);
 * 
 *  return () => {
 *    cancelHead();
 *  };
 * }, []);
 * ```
 * 
 * @param path The API endpoint
 */
var useHeadAsync = function useHeadAsync(path) {
  var http = useHttp();
  var source = Axios.CancelToken.source();

  var headAsync = /*#__PURE__*/function () {
    var _headAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var subPath,
          config,
          dispatch,
          response,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              subPath = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
              config = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              dispatch = _args.length > 2 && _args[2] !== undefined ? _args[2] : function () {};
              subPath = subPath.trim();
              subPath = subPath && "/".concat(subPath);
              config = config === null ? {} : config;
              dispatch({
                type: 'check-loading'
              });
              _context.prev = 7;
              // Set cancelToken for request cancellation
              config.cancelToken = source.token;
              _context.next = 11;
              return http.head("".concat(path).concat(subPath), config);

            case 11:
              response = _context.sent;
              dispatch({
                type: 'check-success'
              });
              _context.next = 20;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](7);

              if (!Axios.isCancel(_context.t0)) {
                _context.next = 19;
                break;
              }

              return _context.abrupt("return");

            case 19:
              dispatch({
                type: 'check-error',
                error: _context.t0
              });

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 15]]);
    }));

    function headAsync() {
      return _headAsync.apply(this, arguments);
    }

    return headAsync;
  }();

  var cancel = function cancel() {
    source.cancel();
  };

  return [headAsync, cancel];
};

/**
 * A generic hook for making a POST request.
 * 
 *```
 * import {
 *  usePostAsync,
 *  useEmptyStateReducer,
 *  Tag,
 * } from '@lyonfuture/api';
 * 
 * const [postAsync, cancelPost] = usePostAsync<Tag>('tags');
 * const [tagsState, tagsDispatch] = useEmptyStateReducer<Tag>();
 * 
 * useEffect(() => {
 *  postAsync('', { name: 'Foo' }, null, tagsDispatch);
 * 
 *  return () => {
 *    cancelPost();
 *  };
 * }, []);
 * ```
 * 
 * @param path The API endpoint
 */
var usePostAsync = function usePostAsync(path) {
  var http = useHttp();
  var source = Axios.CancelToken.source();

  var postAsync = /*#__PURE__*/function () {
    var _postAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var subPath,
          body,
          config,
          dispatch,
          response,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              subPath = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
              body = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              config = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              dispatch = _args.length > 3 && _args[3] !== undefined ? _args[3] : function () {};
              subPath = subPath.trim();
              subPath = subPath && "/".concat(subPath);
              config = config === null ? {} : config;
              dispatch({
                type: 'creating'
              });
              _context.prev = 8;
              // Set cancelToken for request cancellation
              config.cancelToken = source.token;
              _context.next = 12;
              return http.post("".concat(path).concat(subPath), body, config);

            case 12:
              response = _context.sent;
              dispatch({
                type: 'create-success',
                data: response.data
              });
              return _context.abrupt("return", response);

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](8);
              dispatch({
                type: 'create-error',
                error: _context.t0
              });
              throw _context.t0;

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 17]]);
    }));

    function postAsync() {
      return _postAsync.apply(this, arguments);
    }

    return postAsync;
  }();

  var cancel = function cancel() {
    source.cancel();
  };

  return [postAsync, cancel];
};

/**
 * A generic hook for making a PUT request.
 * 
 *```
 * import {
 *  usePutAsync,
 *  useSingleStateReducer,
 *  Tag,
 * } from '@lyonfuture/api';
 * 
 * const [putAsync, cancelPut] = usePutAsync<Tag>('tags');
 * const [tagsState, tagsDispatch] = useSingleStateReducer<Tag>();
 * 
 * useEffect(() => {
 *  putAsync(tagState.data.id, { name: 'Bar' }, null, tagsDispatch);
 * 
 *  return () => {
 *    cancelPut();
 *  };
 * }, []);
 * ```
 * 
 * @param path The API endpoint
 */
var usePutAsync = function usePutAsync(path) {
  var http = useHttp();
  var source = Axios.CancelToken.source();

  var putAsync = /*#__PURE__*/function () {
    var _putAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var subPath,
          body,
          config,
          dispatch,
          action,
          dispatchAction,
          response,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              subPath = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
              body = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              config = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              dispatch = _args.length > 3 && _args[3] !== undefined ? _args[3] : function () {};
              action = _args.length > 4 && _args[4] !== undefined ? _args[4] : 'save';
              subPath = subPath.trim();
              subPath = subPath && "/".concat(subPath);
              config = config === null ? {} : config;

              dispatchAction = function dispatchAction(data, error) {
                if (action === 'save') {
                  !!data ? dispatch({
                    type: 'save-success',
                    data: data
                  }) : !!error ? dispatch({
                    type: 'save-error',
                    error: error
                  }) : dispatch({
                    type: 'saving'
                  });
                } else if (action === 'publish') {
                  !!data ? dispatch({
                    type: 'publish-success',
                    data: data
                  }) : !!error ? dispatch({
                    type: 'publish-error',
                    error: error
                  }) : dispatch({
                    type: 'publishing'
                  });
                } else if (action === 'unpublish') {
                  !!data ? dispatch({
                    type: 'unpublish-success',
                    data: data
                  }) : !!error ? dispatch({
                    type: 'unpublish-error',
                    error: error
                  }) : dispatch({
                    type: 'unpublishing'
                  });
                }
              };

              dispatchAction();
              _context.prev = 10;
              // Set cancelToken for request cancellation
              config.cancelToken = source.token;
              _context.next = 14;
              return http.put("".concat(path).concat(subPath), body, config);

            case 14:
              response = _context.sent;
              dispatchAction(response.data);
              return _context.abrupt("return", response);

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](10);
              dispatchAction(null, _context.t0);
              throw _context.t0;

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[10, 19]]);
    }));

    function putAsync() {
      return _putAsync.apply(this, arguments);
    }

    return putAsync;
  }();

  var cancel = function cancel() {
    source.cancel();
  };

  return [putAsync, cancel];
};

var useLogger = function useLogger(reducer) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var reducerWithLogger = useCallback(function (state, action) {
    var next = reducer(state, action);
    console.group("STATE LOG: ".concat(name));
    console.log("%cPrevious State:", "color: #DADC60; font-weight: 700;", state);
    console.log("%cAction:", "color: #00A7F7; font-weight: 700;", action);
    console.log("%cNext State:", "color: #47B04B; font-weight: 700;", next);
    console.groupEnd();
    return next;
  }, [reducer]);
  return reducerWithLogger;
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var emptyResourceReducerFactory = function emptyResourceReducerFactory() {
  var emptyResource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (state, action) {
    switch (action.type) {
      case 'empty':
        return _objectSpread(_objectSpread({}, state), {}, {
          data: emptyResource
        });

      case 'check-loading':
        return _objectSpread(_objectSpread({}, state), {}, {
          isChecking: true,
          available: false
        });

      case 'check-success':
        return _objectSpread(_objectSpread({}, state), {}, {
          error: null,
          isChecking: false,
          available: true
        });

      case 'check-error':
        return _objectSpread(_objectSpread({}, state), {}, {
          error: action.error,
          isChecking: false,
          available: false
        });

      case 'saving':
        return _objectSpread(_objectSpread({}, state), {}, {
          isSaving: true,
          saved: false
        });

      case 'save-success':
        return _objectSpread(_objectSpread({}, state), {}, {
          data: action.data,
          error: null,
          isSaving: false,
          saved: true
        });

      case 'save-error':
        return _objectSpread(_objectSpread({}, state), {}, {
          data: null,
          error: action.error,
          isSaving: false,
          saved: false
        });

      case 'creating':
        return _objectSpread(_objectSpread({}, state), {}, {
          isCreating: true,
          created: false
        });

      case 'create-success':
        return _objectSpread(_objectSpread({}, state), {}, {
          data: action.data,
          error: null,
          isCreating: false,
          created: true
        });

      case 'create-error':
        return _objectSpread(_objectSpread({}, state), {}, {
          data: null,
          error: action.error,
          isCreating: false,
          created: false
        });

      default:
        return _objectSpread({}, state);
    }
  };
};

var useEmptyStateReducer = function useEmptyStateReducer() {
  var emptyResource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var withLogger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var emptyResourceReducer = emptyResourceReducerFactory(emptyResource);

  if (withLogger) {
    var name = typeof withLogger === 'string' ? "".concat(withLogger) : '';
    emptyResourceReducer = useLogger(emptyResourceReducer, name);
  }

  return useReducer(emptyResourceReducer, {
    data: emptyResource,
    error: null,
    saved: false,
    isSaving: false,
    isCreating: false,
    created: false
  });
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var listResourceReducerFactory = function listResourceReducerFactory() {
  return function (state, action) {
    switch (action.type) {
      case 'loading':
        return _objectSpread$1(_objectSpread$1({}, state), {}, {
          fetched: false,
          isLoading: true
        });

      case 'success':
        return _objectSpread$1(_objectSpread$1({}, state), {}, {
          data: action.data,
          error: null,
          fetched: true,
          isLoading: false
        });

      case 'error':
        return _objectSpread$1(_objectSpread$1({}, state), {}, {
          data: null,
          error: action.error,
          fetched: false,
          isLoading: false
        });

      case 'saving':
        return _objectSpread$1(_objectSpread$1({}, state), {}, {
          isSaving: true,
          saved: false
        });

      case 'save-success':
        return _objectSpread$1(_objectSpread$1({}, state), {}, {
          error: null,
          isSaving: false,
          saved: true
        });

      case 'save-error':
        return _objectSpread$1(_objectSpread$1({}, state), {}, {
          error: action.error,
          isSaving: false,
          saved: false
        });

      case 'deleting':
        return _objectSpread$1(_objectSpread$1({}, state), {}, {
          isDeleting: true,
          deleted: false
        });

      case 'delete-success':
        return _objectSpread$1(_objectSpread$1({}, state), {}, {
          error: null,
          isDeleting: false,
          deleted: true
        });

      case 'delete-error':
        return _objectSpread$1(_objectSpread$1({}, state), {}, {
          error: action.error,
          isDeleting: false,
          deleted: false
        });

      case 'creating':
        return _objectSpread$1(_objectSpread$1({}, state), {}, {
          isCreating: true,
          created: false
        });

      case 'create-success':
        return _objectSpread$1(_objectSpread$1({}, state), {}, {
          error: null,
          isCreating: false,
          created: true
        });

      case 'create-error':
        return _objectSpread$1(_objectSpread$1({}, state), {}, {
          data: null,
          error: action.error,
          isCreating: false,
          created: false
        });

      default:
        return _objectSpread$1({}, state);
    }
  };
};

var useListStateReducer = function useListStateReducer() {
  var withLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var listResourceReducer = listResourceReducerFactory();

  if (withLogger) {
    var name = typeof withLogger === 'string' ? "".concat(withLogger) : '';
    listResourceReducer = useLogger(listResourceReducer, name);
  }

  return useReducer(listResourceReducer, {
    data: null,
    error: null,
    fetched: false,
    saved: false,
    deleted: false,
    isLoading: false,
    isSaving: false,
    isDeleting: false,
    isCreating: false,
    created: false
  });
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var pageResourceReducerFactory = function pageResourceReducerFactory() {
  return function (state, action) {
    switch (action.type) {
      case 'loading':
        return _objectSpread$2(_objectSpread$2({}, state), {}, {
          fetched: false,
          isLoading: true
        });

      case 'success':
        return _objectSpread$2(_objectSpread$2({}, state), {}, {
          data: action.data,
          error: null,
          fetched: true,
          isLoading: false
        });

      case 'error':
        return _objectSpread$2(_objectSpread$2({}, state), {}, {
          data: null,
          error: action.error,
          fetched: false,
          isLoading: false
        });

      case 'saving':
        return _objectSpread$2(_objectSpread$2({}, state), {}, {
          isSaving: true,
          saved: false
        });

      case 'save-success':
        return _objectSpread$2(_objectSpread$2({}, state), {}, {
          error: null,
          isSaving: false,
          saved: true
        });

      case 'save-error':
        return _objectSpread$2(_objectSpread$2({}, state), {}, {
          error: action.error,
          isSaving: false,
          saved: false
        });

      case 'deleting':
        return _objectSpread$2(_objectSpread$2({}, state), {}, {
          isDeleting: true,
          deleted: false
        });

      case 'delete-success':
        return _objectSpread$2(_objectSpread$2({}, state), {}, {
          error: null,
          isDeleting: false,
          deleted: true
        });

      case 'delete-error':
        return _objectSpread$2(_objectSpread$2({}, state), {}, {
          error: action.error,
          isDeleting: false,
          deleted: false
        });

      case 'creating':
        return _objectSpread$2(_objectSpread$2({}, state), {}, {
          isCreating: true,
          created: false
        });

      case 'create-success':
        return _objectSpread$2(_objectSpread$2({}, state), {}, {
          error: null,
          isCreating: false,
          created: true
        });

      case 'create-error':
        return _objectSpread$2(_objectSpread$2({}, state), {}, {
          data: null,
          error: action.error,
          isCreating: false,
          created: false
        });

      default:
        return _objectSpread$2({}, state);
    }
  };
};

var usePageStateReducer = function usePageStateReducer() {
  var withLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var pageResourceReducer = pageResourceReducerFactory();

  if (withLogger) {
    var name = typeof withLogger === 'string' ? "".concat(withLogger) : '';
    pageResourceReducer = useLogger(pageResourceReducer, name);
  }

  return useReducer(pageResourceReducer, {
    data: null,
    error: null,
    fetched: false,
    saved: false,
    deleted: false,
    isLoading: false,
    isSaving: false,
    isDeleting: false,
    isCreating: false,
    created: false
  });
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var singleResourceReducerFactory = function singleResourceReducerFactory() {
  return function (state, action) {
    switch (action.type) {
      case 'loading':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          fetched: false,
          isLoading: true
        });

      case 'success':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          data: action.data,
          error: null,
          fetched: true,
          isLoading: false
        });

      case 'error':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          data: null,
          error: action.error,
          fetched: false,
          isLoading: false
        });

      case 'saving':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          isSaving: true,
          saved: false,
          isPublishing: false,
          published: false,
          isUnpublishing: false,
          unpublished: false
        });

      case 'save-success':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          data: action.data,
          error: null,
          isSaving: false,
          saved: true
        });

      case 'save-error':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          data: null,
          error: action.error,
          isSaving: false,
          saved: false
        });

      case 'deleting':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          isDeleting: true,
          deleted: false,
          isSaving: false,
          saved: false,
          isPublishing: false,
          published: false,
          isUnpublishing: false,
          unpublished: false
        });

      case 'delete-success':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          data: action.data,
          error: null,
          isDeleting: false,
          deleted: true
        });

      case 'delete-error':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          data: null,
          error: action.error,
          isDeleting: false,
          deleted: false
        });

      case 'check-loading':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          isChecking: true,
          available: false
        });

      case 'check-success':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          error: null,
          isChecking: false,
          available: true
        });

      case 'check-error':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          error: action.error,
          isChecking: false,
          available: false
        });

      case 'publishing':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          isPublishing: true,
          published: false,
          isSaving: false,
          saved: false,
          isUnpublishing: false,
          unpublished: false
        });

      case 'publish-success':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          data: action.data,
          publishError: null,
          isPublishing: false,
          published: true
        });

      case 'publish-error':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          publishError: action.error,
          isPublishing: false,
          published: false
        });

      case 'unpublishing':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          isUnpublishing: true,
          unpublished: false,
          isSaving: false,
          saved: false,
          isPublishing: false,
          published: false
        });

      case 'unpublish-success':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          data: action.data,
          unpublishError: null,
          isUnpublishing: false,
          unpublished: true
        });

      case 'unpublish-error':
        return _objectSpread$3(_objectSpread$3({}, state), {}, {
          unpublishError: action.error,
          isUnpublishing: false,
          unpublished: false
        });

      default:
        return _objectSpread$3({}, state);
    }
  };
};

var useSingleStateReducer = function useSingleStateReducer() {
  var withLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var singleResourceReducer = singleResourceReducerFactory();

  if (withLogger) {
    var name = typeof withLogger === 'string' ? "".concat(withLogger) : '';
    singleResourceReducer = useLogger(singleResourceReducer, name);
  }

  return useReducer(singleResourceReducer, {
    data: null,
    error: null,
    fetched: false,
    saved: false,
    deleted: false,
    isLoading: false,
    isSaving: false,
    isDeleting: false
  });
};

/**
 * Base64-encode a Unicode string. The Unicode string is encoded as UTF-8 first.
 * 
 * @param input Unicode string
 */

var base64encode = function base64encode(input) {
  return encode(encode$1(input));
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var resourceHookFactory = function resourceHookFactory(path, methodPathOverride) {
  var emptyResource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  function resourceHook(param1, param2, param3) {
    var _validateParams = validateParams(param1, param2, param3),
        _validateParams2 = _slicedToArray(_validateParams, 3),
        resourceId = _validateParams2[0],
        deps = _validateParams2[1],
        options = _validateParams2[2];

    var mode;
    var state;

    var _useListStateReducer = useListStateReducer(options.useLogger),
        _useListStateReducer2 = _slicedToArray(_useListStateReducer, 2),
        listState = _useListStateReducer2[0],
        listDispatch = _useListStateReducer2[1];

    var _useSingleStateReduce = useSingleStateReducer(options.useLogger),
        _useSingleStateReduce2 = _slicedToArray(_useSingleStateReduce, 2),
        singleState = _useSingleStateReduce2[0],
        singleDispatch = _useSingleStateReduce2[1];

    var _useEmptyStateReducer = useEmptyStateReducer(emptyResource, options.useLogger),
        _useEmptyStateReducer2 = _slicedToArray(_useEmptyStateReducer, 2),
        emptyState = _useEmptyStateReducer2[0],
        emptyDispatch = _useEmptyStateReducer2[1];

    var _usePageStateReducer = usePageStateReducer(options.useLogger),
        _usePageStateReducer2 = _slicedToArray(_usePageStateReducer, 2),
        pageState = _usePageStateReducer2[0],
        pageDispatch = _usePageStateReducer2[1];

    var _useGetAsync = useGetAsync(path),
        _useGetAsync2 = _slicedToArray(_useGetAsync, 2),
        getAsync = _useGetAsync2[0],
        cancelGet = _useGetAsync2[1];

    var _useHeadAsync = useHeadAsync(path),
        _useHeadAsync2 = _slicedToArray(_useHeadAsync, 2),
        headAsync = _useHeadAsync2[0],
        cancelHead = _useHeadAsync2[1];

    var _usePostAsync = usePostAsync(path),
        _usePostAsync2 = _slicedToArray(_usePostAsync, 2),
        postAsync = _usePostAsync2[0],
        cancelPost = _usePostAsync2[1];

    var _usePutAsync = usePutAsync(path),
        _usePutAsync2 = _slicedToArray(_usePutAsync, 2),
        putAsync = _usePutAsync2[0],
        cancelPut = _usePutAsync2[1]; //const [uploadAsync, cancelUpload] = usePutAsync<any>(path);


    var _usePostAsync3 = usePostAsync(path),
        _usePostAsync4 = _slicedToArray(_usePostAsync3, 2),
        uploadAsync = _usePostAsync4[0],
        cancelUpload = _usePostAsync4[1];

    var _useDeleteAsync = useDeleteAsync(path),
        _useDeleteAsync2 = _slicedToArray(_useDeleteAsync, 2),
        deleteAsync = _useDeleteAsync2[0],
        cancelDelete = _useDeleteAsync2[1];

    var getPathOverride = function getPathOverride(method) {
      if (options.methodPathOverride && options.methodPathOverride[method]) {
        return "".concat(options.methodPathOverride[method]);
      }

      if (methodPathOverride && methodPathOverride[method]) {
        return "".concat(methodPathOverride[method]);
      }

      return '';
    };
    /**
     * Used in the 'list' and 'page' states where its data (list/page of resources)
     * automatically gets refreshed after creating, updating, or deleting a resource on-the-fly.
     */


    var createDataRefresher = function createDataRefresher(httpMethod, path, body, config) {
      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatcher) {
          var usePage,
              putAction,
              response,
              _args = arguments;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  usePage = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                  putAction = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'save';
                  _context.prev = 2;

                  if (!(httpMethod === 'POST')) {
                    _context.next = 9;
                    break;
                  }

                  _context.next = 6;
                  return postAsync(path, body, config, dispatcher);

                case 6:
                  response = _context.sent;
                  _context.next = 18;
                  break;

                case 9:
                  if (!(httpMethod === 'PUT')) {
                    _context.next = 15;
                    break;
                  }

                  _context.next = 12;
                  return putAsync(path, body, config, dispatcher, putAction);

                case 12:
                  response = _context.sent;
                  _context.next = 18;
                  break;

                case 15:
                  _context.next = 17;
                  return deleteAsync(path, null, dispatcher);

                case 17:
                  response = _context.sent;

                case 18:
                  getAsync(usePage ? getPathOverride('GET_PAGE') : getPathOverride('GET_LIST'), options.setParams ? {
                    params: options.setParams()
                  } : null, dispatcher);
                  return _context.abrupt("return", response);

                case 22:
                  _context.prev = 22;
                  _context.t0 = _context["catch"](2);

                case 24:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 22]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    };

    if (typeof resourceId === 'string') {
      resourceId = "".concat(resourceId).trim();
    }

    var create = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(body) {
        var params,
            postPath,
            postAndRefreshData,
            response,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
                postPath = (methodPathOverride === null || methodPathOverride === void 0 ? void 0 : methodPathOverride.POST) || '';
                postAndRefreshData = createDataRefresher('POST', postPath, body, {
                  params: params
                });

                if (!(mode === 'empty')) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 6;
                return postAsync(postPath, body, {
                  params: params
                }, emptyDispatch);

              case 6:
                response = _context2.sent;
                _context2.next = 19;
                break;

              case 9:
                if (!(mode === 'list')) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 12;
                return postAndRefreshData(listDispatch);

              case 12:
                response = _context2.sent;
                _context2.next = 19;
                break;

              case 15:
                if (!(mode === 'page')) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 18;
                return postAndRefreshData(pageDispatch, true);

              case 18:
                response = _context2.sent;

              case 19:
                return _context2.abrupt("return", response);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function create(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    var createAndUpload = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(body, formData) {
        var params,
            base64encodeFilename,
            postPath,
            response,
            _methodPathOverride$U,
            id,
            fileName,
            config,
            uploadPath,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : null;
                base64encodeFilename = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : false;
                postPath = (methodPathOverride === null || methodPathOverride === void 0 ? void 0 : methodPathOverride.POST) || '';
                _context3.prev = 3;
                _context3.next = 6;
                return postAsync(postPath, body, {
                  params: params
                }, emptyDispatch);

              case 6:
                response = _context3.sent;
                console.log('createAndUpload response', response);

                if (!(response && response.status === 200)) {
                  _context3.next = 19;
                  break;
                }

                //const id = (response.data as any).id;
                id = response.data.id;
                fileName = "".concat(id, "_").concat(formData.get('fileName'));

                if (base64encodeFilename) {
                  formData.set('fileName', base64encode(fileName));
                } else {
                  formData.set('fileName', fileName);
                }

                config = {
                  headers: {
                    'content-type': 'multipart/form-data'
                  },
                  params: params
                };
                uploadPath = (_methodPathOverride$U = methodPathOverride === null || methodPathOverride === void 0 ? void 0 : methodPathOverride.UPLOAD) !== null && _methodPathOverride$U !== void 0 ? _methodPathOverride$U : 'upload';

                if (!id) {
                  _context3.next = 18;
                  break;
                }

                return _context3.abrupt("return", uploadAsync("".concat(id, "/").concat(uploadPath), formData, config, emptyDispatch));

              case 18:
                return _context3.abrupt("return", uploadAsync("".concat(uploadPath), formData, config, emptyDispatch));

              case 19:
                _context3.next = 24;
                break;

              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3["catch"](3);
                throw _context3.t0;

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[3, 21]]);
      }));

      return function createAndUpload(_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }();

    var cancelCreateAndUpload = function cancelCreateAndUpload() {
      cancelPost();
      cancelUpload();
    };

    var update = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, body) {
        var params,
            putPath,
            putAndRefreshData,
            response,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : null;

                if (!(!options.noFetch && mode === 'single' && !(singleState === null || singleState === void 0 ? void 0 : singleState.data))) {
                  _context4.next = 4;
                  break;
                }

                console.error("[".concat(path, " resource hook] Error: Cannot update a null data."));
                return _context4.abrupt("return");

              case 4:
                console.log('update ABC');
                putPath = (methodPathOverride === null || methodPathOverride === void 0 ? void 0 : methodPathOverride.PUT) ? "".concat(methodPathOverride.PUT, "/") : '';
                putAndRefreshData = createDataRefresher('PUT', "".concat(putPath).concat(id), body, {
                  params: params
                });

                if (!(mode === 'single')) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 10;
                return putAsync("".concat(putPath).concat(id), body, {
                  params: params
                }, singleDispatch);

              case 10:
                response = _context4.sent;
                _context4.next = 23;
                break;

              case 13:
                if (!(mode === 'list')) {
                  _context4.next = 19;
                  break;
                }

                _context4.next = 16;
                return putAndRefreshData(listDispatch);

              case 16:
                response = _context4.sent;
                _context4.next = 23;
                break;

              case 19:
                if (!(mode === 'page')) {
                  _context4.next = 23;
                  break;
                }

                _context4.next = 22;
                return putAndRefreshData(pageDispatch, true);

              case 22:
                response = _context4.sent;

              case 23:
                return _context4.abrupt("return", response);

              case 24:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function update(_x5, _x6) {
        return _ref4.apply(this, arguments);
      };
    }();

    var updateAndUpload = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(body, formData) {
        var params,
            base64encodeFilename,
            id,
            putPath,
            response,
            _rawId$id,
            _methodPathOverride$U2,
            rawId,
            _id,
            fileName,
            config,
            uploadPath,
            _args5 = arguments;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : null;
                base64encodeFilename = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : false;
                id = _args5.length > 4 ? _args5[4] : undefined;
                putPath = "".concat(getPathOverride('POST')).concat(id !== null && id !== void 0 ? id : '');
                _context5.prev = 4;
                _context5.next = 7;
                return putAsync(putPath, body, {
                  params: params
                }, singleDispatch);

              case 7:
                response = _context5.sent;
                console.log('update ABC', response);

                if (!(response && response.status === 200)) {
                  _context5.next = 21;
                  break;
                }

                rawId = response.data.id; // Handle both IdBase { id: string } and plain string

                _id = (_rawId$id = rawId === null || rawId === void 0 ? void 0 : rawId.id) !== null && _rawId$id !== void 0 ? _rawId$id : rawId;
                fileName = "".concat(_id !== null && _id !== void 0 ? _id : 'undefined', "_").concat(formData.get('fileName'));

                if (base64encodeFilename) {
                  formData.set('fileName', base64encode(fileName));
                } else {
                  formData.set('fileName', fileName);
                }

                config = {
                  headers: {
                    'content-type': 'multipart/form-data'
                  },
                  params: params
                };
                uploadPath = (_methodPathOverride$U2 = methodPathOverride === null || methodPathOverride === void 0 ? void 0 : methodPathOverride.UPLOAD) !== null && _methodPathOverride$U2 !== void 0 ? _methodPathOverride$U2 : 'upload';

                if (!_id) {
                  _context5.next = 20;
                  break;
                }

                return _context5.abrupt("return", uploadAsync("".concat(_id, "/").concat(uploadPath), formData, config, emptyDispatch));

              case 20:
                return _context5.abrupt("return", uploadAsync("".concat(uploadPath), formData, config, emptyDispatch));

              case 21:
                _context5.next = 26;
                break;

              case 23:
                _context5.prev = 23;
                _context5.t0 = _context5["catch"](4);
                throw _context5.t0;

              case 26:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[4, 23]]);
      }));

      return function updateAndUpload(_x7, _x8) {
        return _ref5.apply(this, arguments);
      };
    }();

    var cancelUpdateAndUpload = function cancelUpdateAndUpload() {
      cancelPut();
      cancelUpload();
    };

    var remove = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id) {
        var deletePath, deleteAndRefreshData;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!options.noFetch && mode === 'single' && !(singleState === null || singleState === void 0 ? void 0 : singleState.data))) {
                  _context6.next = 3;
                  break;
                }

                console.error("[".concat(path, " resource hook] Error: Cannot delete a null data."));
                return _context6.abrupt("return");

              case 3:
                deletePath = (methodPathOverride === null || methodPathOverride === void 0 ? void 0 : methodPathOverride.DELETE) ? "".concat(methodPathOverride.DELETE, "/") : '';
                deleteAndRefreshData = createDataRefresher('DELETE', "".concat(deletePath).concat(id));

                if (mode === 'single') {
                  deleteAsync("".concat(deletePath).concat(id), null, singleDispatch);
                } else if (mode === 'list') {
                  // auto refresh data
                  deleteAndRefreshData(listDispatch);
                } else if (mode === 'page') {
                  // auto refresh data
                  deleteAndRefreshData(pageDispatch, true);
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function remove(_x9) {
        return _ref6.apply(this, arguments);
      };
    }();

    var check = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(uniqueIdentificator) {
        var headPath, dispatcher;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                headPath = (methodPathOverride === null || methodPathOverride === void 0 ? void 0 : methodPathOverride.HEAD) || '';
                dispatcher = mode === 'empty' ? emptyDispatch : singleDispatch;
                headAsync("".concat(headPath, "/").concat(uniqueIdentificator), options.setParams ? {
                  params: options.setParams()
                } : null, dispatcher);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function check(_x10) {
        return _ref7.apply(this, arguments);
      };
    }();

    var refresh = function refresh(params) {
      getAsync(mode === 'page' ? getPathOverride('GET_PAGE') : getPathOverride('GET_LIST'), params ? {
        params: params
      } : options.setParams ? {
        params: options.setParams()
      } : null, mode === 'page' ? pageDispatch : listDispatch);
    };

    var cancelRefresh = function cancelRefresh() {
      cancelGet();
    };

    var publish = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(id, body, params) {
        var publishPath, _methodPathOverride$P, putAndRefreshData, response;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(mode === 'single' && !(singleState === null || singleState === void 0 ? void 0 : singleState.data))) {
                  _context8.next = 3;
                  break;
                }

                console.error("[".concat(path, " resource hook] Error: Cannot publish a null data."));
                return _context8.abrupt("return");

              case 3:
                publishPath = '/publish';

                if (methodPathOverride) {
                  publishPath = (_methodPathOverride$P = methodPathOverride.PUBLISH) !== null && _methodPathOverride$P !== void 0 ? _methodPathOverride$P : publishPath;
                }

                putAndRefreshData = createDataRefresher('PUT', "".concat(id).concat(publishPath), body, {
                  params: params
                });

                if (!(mode === 'single')) {
                  _context8.next = 12;
                  break;
                }

                _context8.next = 9;
                return putAsync("".concat(id).concat(publishPath), body, {
                  params: params
                }, singleDispatch, 'publish');

              case 9:
                response = _context8.sent;
                _context8.next = 22;
                break;

              case 12:
                if (!(mode === 'list')) {
                  _context8.next = 18;
                  break;
                }

                _context8.next = 15;
                return putAndRefreshData(listDispatch, false, 'publish');

              case 15:
                response = _context8.sent;
                _context8.next = 22;
                break;

              case 18:
                if (!(mode === 'page')) {
                  _context8.next = 22;
                  break;
                }

                _context8.next = 21;
                return putAndRefreshData(pageDispatch, true, 'publish');

              case 21:
                response = _context8.sent;

              case 22:
                return _context8.abrupt("return", response);

              case 23:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function publish(_x11, _x12, _x13) {
        return _ref8.apply(this, arguments);
      };
    }();

    var cancelPublish = function cancelPublish() {
      cancelPut();
    };

    var unpublish = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(id, body, params) {
        var unpublishPath, _methodPathOverride$U3, putAndRefreshData, response;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(mode === 'single' && !(singleState === null || singleState === void 0 ? void 0 : singleState.data))) {
                  _context9.next = 3;
                  break;
                }

                console.error("[".concat(path, " resource hook] Error: Cannot unpublish a null data."));
                return _context9.abrupt("return");

              case 3:
                unpublishPath = '/unpublish';

                if (methodPathOverride) {
                  unpublishPath = (_methodPathOverride$U3 = methodPathOverride.UNPUBLISH) !== null && _methodPathOverride$U3 !== void 0 ? _methodPathOverride$U3 : unpublishPath;
                }

                putAndRefreshData = createDataRefresher('PUT', "".concat(id).concat(unpublishPath), body, {
                  params: params
                });

                if (!(mode === 'single')) {
                  _context9.next = 12;
                  break;
                }

                _context9.next = 9;
                return putAsync("".concat(id).concat(unpublishPath), body, {
                  params: params
                }, singleDispatch, 'unpublish');

              case 9:
                response = _context9.sent;
                _context9.next = 22;
                break;

              case 12:
                if (!(mode === 'list')) {
                  _context9.next = 18;
                  break;
                }

                _context9.next = 15;
                return putAndRefreshData(listDispatch, false, 'unpublish');

              case 15:
                response = _context9.sent;
                _context9.next = 22;
                break;

              case 18:
                if (!(mode === 'page')) {
                  _context9.next = 22;
                  break;
                }

                _context9.next = 21;
                return putAndRefreshData(pageDispatch, true, 'unpublish');

              case 21:
                response = _context9.sent;

              case 22:
                return _context9.abrupt("return", response);

              case 23:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function unpublish(_x14, _x15, _x16) {
        return _ref9.apply(this, arguments);
      };
    }();

    var cancelUnpublish = function cancelUnpublish() {
      cancelPut();
    }; // Determine what state we need to return


    if (resourceId === null) {
      mode = 'empty';
      state = _objectSpread$4(_objectSpread$4({}, emptyState), {}, {
        create: create,
        createAndUpload: createAndUpload,
        cancelCreateAndUpload: cancelCreateAndUpload,
        cancelCreate: cancelPost,
        check: check,
        cancelCheck: cancelHead
      });
    } else if (resourceId) {
      mode = 'single';
      state = _objectSpread$4(_objectSpread$4({}, singleState), {}, {
        check: check,
        cancelCheck: cancelHead,
        update: update,
        updateAndUpload: updateAndUpload,
        cancelUpdateAndUpload: cancelUpdateAndUpload,
        cancelUpdate: cancelPut,
        remove: remove,
        cancelRemove: cancelDelete,
        publish: publish,
        cancelPublish: cancelPublish,
        unpublish: unpublish,
        cancelUnpublish: cancelUnpublish
      });
    } else if (options.paginated) {
      mode = 'page';
      state = _objectSpread$4(_objectSpread$4({}, pageState), {}, {
        cancel: cancelGet,
        create: create,
        cancelCreate: cancelPost,
        update: update,
        cancelUpdate: cancelPut,
        remove: remove,
        cancelRemove: cancelDelete,
        refresh: refresh,
        cancelRefresh: cancelRefresh
      });
    } else {
      mode = 'list';
      state = _objectSpread$4(_objectSpread$4({}, listState), {}, {
        cancel: cancelGet,
        create: create,
        cancelCreate: cancelPost,
        update: update,
        cancelUpdate: cancelPut,
        remove: remove,
        cancelRemove: cancelDelete,
        refresh: refresh,
        cancelRefresh: cancelRefresh
      });
    }

    useEffect(function () {
      switch (mode) {
        case 'empty':
          emptyDispatch({
            type: 'empty'
          });
          break;

        case 'single':
          if (options.noFetch) {
            singleDispatch({
              type: 'success',
              data: null
            });
          } else {
            getAsync("".concat(resourceId), options.setParams ? {
              params: options.setParams()
            } : null, singleDispatch);
          }

          break;

        case 'list':
          getAsync(getPathOverride('GET_LIST'), options.setParams ? {
            params: options.setParams()
          } : null, listDispatch);
          break;

        case 'page':
          getAsync(getPathOverride('GET_PAGE'), options.setParams ? {
            params: options.setParams()
          } : null, pageDispatch);
          break;
      }
    }, deps);
    return state;
  }
  return resourceHook;
};

var validateParams = function validateParams(param1, param2, param3) {
  var resourceId;
  var deps = [];
  var options = {};

  if (Array.isArray(param1)) {
    deps = param1;
  } else {
    resourceId = param1;
  }

  if (Array.isArray(param2)) {
    if (Array.isArray(param1)) {
      throw Error('The 1st and 2nd arguments can\'t be both an array.');
    }

    deps = param2;
  } else if (param2) {
    options = param2;
  }

  if (param3) {
    if (!Array.isArray(param2) && param2) {
      throw Error('The 2nd and 3rd arguments can\'t be both an options.');
    }

    options = param3;
  }

  return [resourceId, deps, options];
};

var methodPathOverride = {
  GET_LIST: 'all'
};
var useAccounts = resourceHookFactory('content/accounts', methodPathOverride);

var methodPathOverride$1 = {
  'HEAD': 'slug',
  'PUBLISH': '',
  'UNPUBLISH': ''
};
var useArticles = resourceHookFactory('content/article', methodPathOverride$1);

var methodPathOverride$2 = {};
/**
 * The Attachments API endpoint.
 */

/**
 * ## The Attachments Resource Hook
 * 
 * #### - Getting List of Resources:
 * ```
 * const state = useAttachments() as ListAttachmentsState;
 * ```
 * 
 * #### - Passing Dependency List and Options.
 * ```
 * const [tagFilters, setTagFilters] = useState([]);
 * // add tagFilters to the useAttachments' internal useEffect dependency list
 * const state = useAttachments([tagFilters], { setParams }) as ListAttachmentsState;
 * // callback function to set the query parameters
 * function setParams() {
 *    return {
 *      tags: tagFilters.map(tag => tag.id)
 *    };
 * }
 * ```
 * 
 * #### Getting Single Resource:
 * ```
 * const state = useAttachments(id) as SingleAttachmentState;
 * // to update the data
 * state.update(id, data);
 * // to delete the data
 * state.remove(id);
 * ```
 * 
 * #### Getting Empty Resource:
 * ```javascript
 * const state = useAttachments(null) as EmptyAttachmentState;
 * // to create a new data
 * state.create(data);
 * ```
 * 
 */

var useAttachments = resourceHookFactory('bht/author/attachments', methodPathOverride$2);

var useAttachmentGroups = resourceHookFactory('exam/editor/attachments/groups');

var methodPathOverride$3 = {
  GET_LIST: 'authors'
};
/**
 * ## The Authors Resource Hook
 * 
 * #### - Getting List of Resources:
 * ```
 * const state = useAuthors() as ListAuthorsState;
 * ```
 * 
 * #### - Passing Dependency List and Options.
 * ```
 * const [tagFilters, setTagFilters] = useState([]);
 * // add tagFilters to the useAuthors' internal useEffect dependency list
 * const state = useAuthors([tagFilters], { setParams }) as ListAuthorsState;
 * // callback function to set the query parameters
 * function setParams() {
 *    return {
 *      tags: tagFilters.map(tag => tag.id)
 *    };
 * }
 * ```
 * 
 * #### Getting Single Resource:
 * ```
 * const state = useAuthors(authorId) as SingleAuthorsState;
 * // to update the data
 * state.update(authorId, data);
 * // to delete the data
 * state.remove(authorId);
 * ```
 * 
 * #### Getting Empty Resource:
 * ```javascript
 * const state = useAuthors(null) as EmptyAuthorsState;
 * // to create a new data
 * state.create(data);
 * ```
 * 
 */

var useAuthors = resourceHookFactory('bht/author', methodPathOverride$3);

/**
 * ## The CourseAuthors Resource Hook
 * 
 * #### - Getting List of Resources:
 * ```
 * const state = useCourseAuthors() as ListCourseAuthorsState;
 * ```
 * 
 * #### - Passing Dependency List and Options.
 * ```
 * const [tagFilters, setTagFilters] = useState([]);
 * // add tagFilters to the useCourseAuthors' internal useEffect dependency list
 * const state = useCourseAuthors([tagFilters], { setParams }) as ListCourseAuthorsState;
 * // callback function to set the query parameters
 * function setParams() {
 *    return {
 *      tags: tagFilters.map(tag => tag.id)
 *    };
 * }
 * ```
 * 
 * #### Getting Single Resource:
 * ```
 * const state = useCourseAuthors(CourseauthorId) as SingleCourseAuthorsState;
 * // to update the data
 * state.update(CourseauthorId, data);
 * // to delete the data
 * state.remove(CourseauthorId);
 * ```
 * 
 * #### Getting Empty Resource:
 * ```javascript
 * const state = useCourseAuthors(null) as EmptyCourseAuthorsState;
 * // to create a new data
 * state.create(data);
 * ```
 * 
 */

var useCourseAuthors = resourceHookFactory('exam/editor/authors');

var _POSITIONS;
var POSITIONS = (_POSITIONS = {}, _defineProperty(_POSITIONS, Language.ENGLISH, [{
  key: "HMS_ADVISOR",
  value: "HMS_ADVISOR",
  text: "HSE Advisor"
}, {
  key: "COMPANY_NURSE",
  value: "COMPANY_NURSE",
  text: "Company Nurse"
} // Other positions in English...
]), _defineProperty(_POSITIONS, Language.NORWEGIAN, [{
  key: "HMS_ADVISOR",
  value: "HMS_ADVISOR",
  text: "HMS-rådgiver"
}, {
  key: "COMPANY_NURSE",
  value: "COMPANY_NURSE",
  text: "Bedriftssykepleier"
} // Other positions in Norwegian...
]), _defineProperty(_POSITIONS, Language.POLISH, [{
  key: "HMS_ADVISOR",
  value: "HMS_ADVISOR",
  text: "Doradca BHP"
}, {
  key: "COMPANY_NURSE",
  value: "COMPANY_NURSE",
  text: "Pielęgniarka firmowa"
} // Other positions in Polish...
]), _defineProperty(_POSITIONS, Language.LITHUANIAN, [{
  key: "HMS_ADVISOR",
  value: "HMS_ADVISOR",
  text: "SAUGOS IR SVEIKATOS KONSULTANTAS"
}, {
  key: "COMPANY_NURSE",
  value: "COMPANY_NURSE",
  text: "Įmonės slaugytoja"
} // Other positions in Lithuanian...
]), _POSITIONS);

var usePositions = function usePositions(language) {
  var _useListStateReducer = useListStateReducer(),
      _useListStateReducer2 = _slicedToArray(_useListStateReducer, 2),
      listState = _useListStateReducer2[0],
      listDispatch = _useListStateReducer2[1];

  useEffect(function () {
    listDispatch({
      type: 'success',
      data: POSITIONS[language]
    });
  }, [language]);
  return listState;
};

var methodPathOverride$4 = {
  'PUT': '',
  'UPLOAD': 'encodedupload'
};
var useBhtDocuments = resourceHookFactory('content/bhtdocument', methodPathOverride$4);

var _CATEGORIES, _HMS_ARBEIDSMILJO, _HMS, _ARBEIDSTID_OG_LONN, _LEDER, _SAFETY_REPRESENTATIV, _SYKEFRAVAER, _OPPSIGELSE_OG_NEDBEM, _FERIE, _PERMITTERING_OG_PERM, _ANSETTELSE, _PERSONVERN, _SYSTEMATISK_HMS_ARBE, _ARBEIDSHELSE, _FYSISK_KJEMISK_OG_BI, _PSYKOSOSIALT, _ERGONOMISK, _HR, _INTERNAL;
var CATEGORIES = (_CATEGORIES = {}, _defineProperty(_CATEGORIES, Language.ENGLISH, [{
  key: "HMS_ARBEIDSMILJO",
  value: "HMS_ARBEIDSMILJO",
  text: "HSE and work environment"
}, {
  key: "HMS",
  value: "HMS",
  text: "HSE"
}, {
  key: "LEDER",
  value: "LEDER",
  text: "Management"
}, {
  key: "SAFETY_REPRESENTATIVE",
  value: "SAFETY_REPRESENTATIVE",
  text: "Safety representative"
}, {
  key: "LEDERSTOTTE",
  value: "LEDERSTOTTE",
  text: "Leadership support"
}, {
  key: "FERIE_OG_FRAVAR",
  value: "FERIE_OG_FRAVAR",
  text: "Vacation and absence"
}, {
  key: "SYSTEMATISK_HMS_ARBEID",
  value: "SYSTEMATISK_HMS_ARBEID",
  text: "Systematic HSE work"
}, {
  key: "ARBEIDSHELSE",
  value: "ARBEIDSHELSE",
  text: "Occupational health"
}, {
  key: "FYSISK_KJEMISK_OG_BIOLOGISK",
  value: "FYSISK_KJEMISK_OG_BIOLOGISK",
  text: "Physical, chemical and biological"
}, {
  key: "PSYKOSOSIALT",
  value: "PSYKOSOSIALT",
  text: "Psychosocial and organizational"
}, {
  key: "ERGONOMISK",
  value: "ERGONOMISK",
  text: "Ergonomic"
}, {
  key: "HR",
  value: "HR",
  text: "HR"
}, {
  key: "INTERNAL",
  value: "INTERNAL",
  text: "Internal"
}]), _defineProperty(_CATEGORIES, Language.NORWEGIAN, [{
  key: "HMS_ARBEIDSMILJO",
  value: "HMS_ARBEIDSMILJO",
  text: "HMS og arbeidmiljø"
}, {
  key: "HMS",
  value: "HMS",
  text: "HMS"
}, {
  key: "LEDER",
  value: "LEDER",
  text: "Ledelse"
}, {
  key: "SAFETY_REPRESENTATIVE",
  value: "SAFETY_REPRESENTATIVE",
  text: "Sikkerhet"
}, {
  key: "LEDERSTOTTE",
  value: "LEDERSTOTTE",
  text: "Lederstøtte"
}, {
  key: "FERIE_OG_FRAVAR",
  value: "FERIE_OG_FRAVAR",
  text: "Ferie og fravær"
}, {
  key: "SYSTEMATISK_HMS_ARBEID",
  value: "SYSTEMATISK_HMS_ARBEID",
  text: "Systematisk HMS-arbeid"
}, {
  key: "ARBEIDSHELSE",
  value: "ARBEIDSHELSE",
  text: "Arbeidshelse"
}, {
  key: "FYSISK_KJEMISK_OG_BIOLOGISK",
  value: "FYSISK_KJEMISK_OG_BIOLOGISK",
  text: "Fysisk, kjemisk og biologisk"
}, {
  key: "PSYKOSOSIALT",
  value: "PSYKOSOSIALT",
  text: "Psykososialt og organisatorisk"
}, {
  key: "ERGONOMISK",
  value: "ERGONOMISK",
  text: "Ergonomisk"
}, {
  key: "HR",
  value: "HR",
  text: "HR"
}, {
  key: "INTERNAL",
  value: "INTERNAL",
  text: "Intern"
}]), _defineProperty(_CATEGORIES, Language.LITHUANIAN, [{
  key: "HMS_ARBEIDSMILJO",
  value: "HMS_ARBEIDSMILJO",
  text: "HMS ir darbo aplinka"
}, {
  key: "HMS",
  value: "HMS",
  text: "HMS"
}, {
  key: "LEDER",
  value: "LEDER",
  text: "Vadovavimas"
}, {
  key: "SAFETY_REPRESENTATIVE",
  value: "SAFETY_REPRESENTATIVE",
  text: "Saugumas"
}, {
  key: "LEDERSTOTTE",
  value: "LEDERSTOTTE",
  text: "Vadovo palaikymas"
}, {
  key: "FERIE_OG_FRAVAR",
  value: "FERIE_OG_FRAVAR",
  text: "Atostogos ir nebuvimas"
}, {
  key: "SYSTEMATISK_HMS_ARBEID",
  value: "SYSTEMATISK_HMS_ARBEID",
  text: "Sisteminis HMS darbas"
}, {
  key: "ARBEIDSHELSE",
  value: "ARBEIDSHELSE",
  text: "Darbo sveikata"
}, {
  key: "FYSISK_KJEMISK_OG_BIOLOGISK",
  value: "FYSISK_KJEMISK_OG_BIOLOGISK",
  text: "Fiziniai, cheminiai ir biologiniai"
}, {
  key: "PSYKOSOSIALT",
  value: "PSYKOSOSIALT",
  text: "Psichosocialinis ir organizacinis"
}, {
  key: "ERGONOMISK",
  value: "ERGONOMISK",
  text: "Ergonominis"
}, {
  key: "HR",
  value: "HR",
  text: "HR"
}, {
  key: "INTERNAL",
  value: "INTERNAL",
  text: "Vidinis"
}]), _defineProperty(_CATEGORIES, Language.POLISH, [{
  key: "HMS_ARBEIDSMILJO",
  value: "HMS_ARBEIDSMILJO",
  text: "BHP i środowisko pracy"
}, {
  key: "HMS",
  value: "HMS",
  text: "BHP"
}, {
  key: "LEDER",
  value: "LEDER",
  text: "Zarządzanie"
}, {
  key: "SAFETY_REPRESENTATIVE",
  value: "SAFETY_REPRESENTATIVE",
  text: "Bezpieczeństwo"
}, {
  key: "LEDERSTOTTE",
  value: "LEDERSTOTTE",
  text: "Wsparcie kierownictwa"
}, {
  key: "FERIE_OG_FRAVAR",
  value: "FERIE_OG_FRAVAR",
  text: "Urlopy i absencja"
}, {
  key: "SYSTEMATISK_HMS_ARBEID",
  value: "SYSTEMATISK_HMS_ARBEID",
  text: "Systematyczna praca BHP"
}, {
  key: "ARBEIDSHELSE",
  value: "ARBEIDSHELSE",
  text: "Zdrowie zawodowe"
}, {
  key: "FYSISK_KJEMISK_OG_BIOLOGISK",
  value: "FYSISK_KJEMISK_OG_BIOLOGISK",
  text: "Fizyczne, chemiczne i biologiczne"
}, {
  key: "PSYKOSOSIALT",
  value: "PSYKOSOSIALT",
  text: "Psychospołeczne i organizacyjne"
}, {
  key: "ERGONOMISK",
  value: "ERGONOMISK",
  text: "Ergonomiczne"
}, {
  key: "HR",
  value: "HR",
  text: "HR"
}, {
  key: "INTERNAL",
  value: "INTERNAL",
  text: "Wewnętrzny"
}]), _CATEGORIES);
var CATEGORIES_LANGUAGE_MAP = {
  'HMS_ARBEIDSMILJO': (_HMS_ARBEIDSMILJO = {}, _defineProperty(_HMS_ARBEIDSMILJO, Language.ENGLISH, 'HSE and work environment'), _defineProperty(_HMS_ARBEIDSMILJO, Language.NORWEGIAN, 'HMS og arbeidmiljø'), _defineProperty(_HMS_ARBEIDSMILJO, Language.LITHUANIAN, 'HMS ir darbo aplinka'), _defineProperty(_HMS_ARBEIDSMILJO, Language.POLISH, 'BHP i środowisko pracy'), _HMS_ARBEIDSMILJO),
  'HMS': (_HMS = {}, _defineProperty(_HMS, Language.ENGLISH, 'HSE'), _defineProperty(_HMS, Language.NORWEGIAN, 'HMS'), _defineProperty(_HMS, Language.LITHUANIAN, 'HMS'), _defineProperty(_HMS, Language.POLISH, 'BHP'), _HMS),
  'ARBEIDSTID_OG_LONN': (_ARBEIDSTID_OG_LONN = {}, _defineProperty(_ARBEIDSTID_OG_LONN, Language.ENGLISH, 'Working hours and wages'), _defineProperty(_ARBEIDSTID_OG_LONN, Language.NORWEGIAN, 'Arbeidstid og lønn'), _defineProperty(_ARBEIDSTID_OG_LONN, Language.LITHUANIAN, 'Darbo laikas ir atlyginimas'), _defineProperty(_ARBEIDSTID_OG_LONN, Language.POLISH, 'Czas pracy i'), _ARBEIDSTID_OG_LONN),
  'LEDER': (_LEDER = {}, _defineProperty(_LEDER, Language.ENGLISH, 'Management'), _defineProperty(_LEDER, Language.NORWEGIAN, 'Ledelse'), _defineProperty(_LEDER, Language.LITHUANIAN, 'Vadovavimas'), _defineProperty(_LEDER, Language.POLISH, 'Zarządzanie'), _LEDER),
  'SAFETY_REPRESENTATIVE': (_SAFETY_REPRESENTATIV = {}, _defineProperty(_SAFETY_REPRESENTATIV, Language.ENGLISH, 'Safety representative'), _defineProperty(_SAFETY_REPRESENTATIV, Language.NORWEGIAN, 'Sikkerhet'), _defineProperty(_SAFETY_REPRESENTATIV, Language.LITHUANIAN, 'Saugumas'), _defineProperty(_SAFETY_REPRESENTATIV, Language.POLISH, 'Bezpieczeństwo'), _SAFETY_REPRESENTATIV),
  'SYKEFRAVAER': (_SYKEFRAVAER = {}, _defineProperty(_SYKEFRAVAER, Language.ENGLISH, 'Absence'), _defineProperty(_SYKEFRAVAER, Language.NORWEGIAN, 'Sykefravær'), _defineProperty(_SYKEFRAVAER, Language.LITHUANIAN, 'Nebuvimas'), _defineProperty(_SYKEFRAVAER, Language.POLISH, 'Absencja'), _SYKEFRAVAER),
  'OPPSIGELSE_OG_NEDBEMANNING': (_OPPSIGELSE_OG_NEDBEM = {}, _defineProperty(_OPPSIGELSE_OG_NEDBEM, Language.ENGLISH, 'Termination and staffing'), _defineProperty(_OPPSIGELSE_OG_NEDBEM, Language.NORWEGIAN, 'Oppsigelse og nedbemanning'), _defineProperty(_OPPSIGELSE_OG_NEDBEM, Language.LITHUANIAN, 'Atleidimas ir darbuotojų skaičiaus mažinimas'), _defineProperty(_OPPSIGELSE_OG_NEDBEM, Language.POLISH, 'Zwolnienia i redukcje'), _OPPSIGELSE_OG_NEDBEM),
  'FERIE': (_FERIE = {}, _defineProperty(_FERIE, Language.ENGLISH, 'Vacation'), _defineProperty(_FERIE, Language.NORWEGIAN, 'Ferie'), _defineProperty(_FERIE, Language.LITHUANIAN, 'Atostogos'), _defineProperty(_FERIE, Language.POLISH, 'Urlopy'), _FERIE),
  'PERMITTERING_OG_PERMISJON': (_PERMITTERING_OG_PERM = {}, _defineProperty(_PERMITTERING_OG_PERM, Language.ENGLISH, 'Layoffs and leave'), _defineProperty(_PERMITTERING_OG_PERM, Language.NORWEGIAN, 'Permittering og permisjon'), _defineProperty(_PERMITTERING_OG_PERM, Language.LITHUANIAN, 'Atleidimas ir atostogos'), _defineProperty(_PERMITTERING_OG_PERM, Language.POLISH, 'Zwolnienia i urlopy'), _PERMITTERING_OG_PERM),
  'ANSETTELSE': (_ANSETTELSE = {}, _defineProperty(_ANSETTELSE, Language.ENGLISH, 'Hiring'), _defineProperty(_ANSETTELSE, Language.NORWEGIAN, 'Ansettelse'), _defineProperty(_ANSETTELSE, Language.LITHUANIAN, 'Darbuotojų samdymas'), _defineProperty(_ANSETTELSE, Language.POLISH, 'Zatrudnienie'), _ANSETTELSE),
  'PERSONVERN': (_PERSONVERN = {}, _defineProperty(_PERSONVERN, Language.ENGLISH, 'Privacy'), _defineProperty(_PERSONVERN, Language.NORWEGIAN, 'Personvern'), _defineProperty(_PERSONVERN, Language.LITHUANIAN, 'Privatumas'), _defineProperty(_PERSONVERN, Language.POLISH, 'Prywatność'), _PERSONVERN),
  'SYSTEMATISK_HMS_ARBEID': (_SYSTEMATISK_HMS_ARBE = {}, _defineProperty(_SYSTEMATISK_HMS_ARBE, Language.ENGLISH, 'Systematic HSE work'), _defineProperty(_SYSTEMATISK_HMS_ARBE, Language.NORWEGIAN, 'Systematisk HMS-arbeid'), _defineProperty(_SYSTEMATISK_HMS_ARBE, Language.LITHUANIAN, 'Sisteminis HMS darbas'), _defineProperty(_SYSTEMATISK_HMS_ARBE, Language.POLISH, 'Systematyczna praca BHP'), _SYSTEMATISK_HMS_ARBE),
  'ARBEIDSHELSE': (_ARBEIDSHELSE = {}, _defineProperty(_ARBEIDSHELSE, Language.ENGLISH, 'Occupational health'), _defineProperty(_ARBEIDSHELSE, Language.NORWEGIAN, 'Arbeidshelse'), _defineProperty(_ARBEIDSHELSE, Language.LITHUANIAN, 'Darbo sveikata'), _defineProperty(_ARBEIDSHELSE, Language.POLISH, 'Zdrowie zawodowe'), _ARBEIDSHELSE),
  'FYSISK_KJEMISK_OG_BIOLOGISK': (_FYSISK_KJEMISK_OG_BI = {}, _defineProperty(_FYSISK_KJEMISK_OG_BI, Language.ENGLISH, 'Physical, chemical and biological'), _defineProperty(_FYSISK_KJEMISK_OG_BI, Language.NORWEGIAN, 'Fysisk, kjemisk og biologisk'), _defineProperty(_FYSISK_KJEMISK_OG_BI, Language.LITHUANIAN, 'Fiziniai, cheminiai ir biologiniai'), _defineProperty(_FYSISK_KJEMISK_OG_BI, Language.POLISH, 'Fizyczne, chemiczne i biologiczne'), _FYSISK_KJEMISK_OG_BI),
  'PSYKOSOSIALT': (_PSYKOSOSIALT = {}, _defineProperty(_PSYKOSOSIALT, Language.ENGLISH, 'Psychosocial and organizational'), _defineProperty(_PSYKOSOSIALT, Language.NORWEGIAN, 'Psykososialt og organisatorisk'), _defineProperty(_PSYKOSOSIALT, Language.LITHUANIAN, 'Psichosocialinis ir organizacinis'), _defineProperty(_PSYKOSOSIALT, Language.POLISH, 'Psychospołeczne i organizacyjne'), _PSYKOSOSIALT),
  'ERGONOMISK': (_ERGONOMISK = {}, _defineProperty(_ERGONOMISK, Language.ENGLISH, 'Ergonomic'), _defineProperty(_ERGONOMISK, Language.NORWEGIAN, 'Ergonomisk'), _defineProperty(_ERGONOMISK, Language.LITHUANIAN, 'Ergonominis'), _defineProperty(_ERGONOMISK, Language.POLISH, 'Ergonomiczne'), _ERGONOMISK),
  'HR': (_HR = {}, _defineProperty(_HR, Language.ENGLISH, 'HR'), _defineProperty(_HR, Language.NORWEGIAN, 'HR'), _defineProperty(_HR, Language.LITHUANIAN, 'HR'), _defineProperty(_HR, Language.POLISH, 'HR'), _HR),
  'INTERNAL': (_INTERNAL = {}, _defineProperty(_INTERNAL, Language.ENGLISH, 'Internal'), _defineProperty(_INTERNAL, Language.NORWEGIAN, 'Intern'), _defineProperty(_INTERNAL, Language.LITHUANIAN, 'Vidinis'), _defineProperty(_INTERNAL, Language.POLISH, 'Wewnętrzny'), _INTERNAL)
};

/**
 * ## The Categories Resource Hook
 * 
 * #### Getting the categories
 * ```javascript
 * import {
 *  KeyValueText,
 *  Language,
 *  useCategories,
 * } from '@lyonfuture/api';
 *
 * const categories = useCategories(Language.ENGLISH).data as KeyValueText[];
 * ```
 */

var useCategories = function useCategories(language) {
  var _useListStateReducer = useListStateReducer(),
      _useListStateReducer2 = _slicedToArray(_useListStateReducer, 2),
      listState = _useListStateReducer2[0],
      listDispatch = _useListStateReducer2[1];

  useEffect(function () {
    listDispatch({
      type: 'loading'
    });
    setTimeout(function () {
      listDispatch({
        type: 'success',
        data: CATEGORIES[language]
      });
    });
  }, [language]);
  return listState;
};

var methodPathOverride$5 = {
  'HEAD': 'slug',
  'PUBLISH': '',
  'UNPUBLISH': ''
};
var useCourse = resourceHookFactory('exam/editor/courses', methodPathOverride$5);

var useDiplomaTemplates = resourceHookFactory('exam/editor/template');

var useDiplomas = resourceHookFactory('exam/editor/diploma');

var useEvents = resourceHookFactory('content/events');

var useExamQuestions = resourceHookFactory('exam/editor/exam/questions');

var useExams = resourceHookFactory('exam/editor/exams');

/**
 * ## The Faqs Resource Hook
 * 
 * #### - Getting List of Resources:
 * ```
 * const state = useFaqs() as ListFaqsState;
 * ```
 * 
 * #### - Passing Dependency List and Options.
 * ```
 * const [tagFilters, setTagFilters] = useState([]);
 * // add tagFilters to the useFaqs' internal useEffect dependency list
 * const state = useFaqs([tagFilters], { setParams }) as ListFaqsState;
 * // callback function to set the query parameters
 * function setParams() {
 *    return {
 *      tags: tagFilters.map(tag => tag.id)
 *    };
 * }
 * ```
 * 
 * #### Getting Single Resource:
 * ```
 * const state = useFaqs(faqId) as SingleFaqsState;
 * // to update the data
 * state.update(faqId, data);
 * // to delete the data
 * state.remove(faqId);
 * ```
 * 
 * #### Getting Empty Resource:
 * ```javascript
 * const state = useFaqs(null) as EmptyFaqsState;
 * // to create a new data
 * state.create(data);
 * ```
 * 
 */

var useFaqs = resourceHookFactory('content/faqs');

var methodPathOverride$6 = {
  // Add your overrides here
  'PUT': ''
};
var useFreeTextQuestions = resourceHookFactory('exam/editor/free-text-questions', methodPathOverride$6);

/**
 * The Images API endpoint.
 */

/**
 * ## The Images Resource Hook
 * 
 * #### - Getting List of Resources:
 * ```
 * const state = useImages() as ListImagesState;
 * ```
 * 
 * #### - Passing Dependency List and Options.
 * ```
 * const [tagFilters, setTagFilters] = useState([]);
 * // add tagFilters to the useImages' internal useEffect dependency list
 * const state = useImages([tagFilters], { setParams }) as ListImagesState;
 * // callback function to set the query parameters
 * function setParams() {
 *    return {
 *      tags: tagFilters.map(tag => tag.id)
 *    };
 * }
 * ```
 * 
 * #### Getting Single Resource:
 * ```
 * const state = useImages(id) as SingleImagesState;
 * // to update the data
 * state.update(id, data);
 * // to delete the data
 * state.remove(id);
 * ```
 * 
 * #### Getting Empty Resource:
 * ```javascript
 * const state = useImages(null) as EmptyImagesState;
 * // to create a new data
 * state.create(data);
 * ```
 * 
 */

var useImages = resourceHookFactory('bht/image');

var methodPathOverride$7 = {
  'GET_LIST': 'list',
  'POST': 'create',
  'PUT': 'update'
};
/**
 * ## The Industry Resource Hook
 * 
 * #### - Getting List of Resources:
 * ```
 * const state = useIndustries() as ListIndustriesState;
 * ```
 * 
 * #### Getting Single Resource:
 * ```
 * const state = useIndustries(industryId) as SingleIndustryState;
 * // to update the data
 * state.update(industryId, data);
 * // to delete the data
 * state.remove(industryId);
 * ```
 * 
 * #### Getting Empty Resource:
 * ```javascript
 * const state = useIndustries(null) as EmptyIndustryState;
 * // to create a new data
 * state.create(data);
 * ```
 * 
 */

var useIndustries = resourceHookFactory('content/industry', methodPathOverride$7);

var SECTORS = [{
  "id": "sector-11",
  "name": "Bilpleie/verksted"
}, {
  "id": "sector-4",
  "name": "Bygg og anlegg"
}, {
  "id": "sector-3",
  "name": "EL"
}, {
  "id": "sector-10",
  "name": "Frisør og skjønnhetspleie"
}, {
  "id": "sector-1",
  "name": "Generell"
}, {
  "id": "sector-9",
  "name": "Helse"
}, {
  "id": "sector-2",
  "name": "Næringsmiddel"
}, {
  "id": "sector-7",
  "name": "Renhold"
}, {
  "id": "sector-6",
  "name": "Restaurant"
}, {
  "id": "sector-5",
  "name": "Transport"
}, {
  "id": "sector-8",
  "name": "Undervisning"
}];

/**
 * ## The Sector Resource Hook
 * 
 * #### - Getting List of Resources:
 * ```
 * const state = useSectors() as ListSectorsState;
 * ```
 * 
 * #### Getting Single Resource:
 * ```
 * const state = useSectors(sectorId) as SingleSectorState;
 * // to update the data
 * state.update(sectorId, data);
 * // to delete the data
 * state.remove(sectorId);
 * ```
 * 
 * #### Getting Empty Resource:
 * ```javascript
 * const state = useSectors(null) as EmptySectorState;
 * // to create a new data
 * state.create(data);
 * ```
 * 
 */
// export const useSectors = resourceHookFactory
//   <Sector, ListSectorsState, SingleSectorState, EmptySectorState, PageSectorState>
//     ('content/sectors');
//Handcoded for now

var useSectors = function useSectors() {
  return {
    data: SECTORS,
    fetched: true,
    saved: false,
    deleted: false,
    isLoading: false,
    isSaving: false,
    isDeleting: false,
    isCreating: false,
    created: false,
    error: null,
    // CanCreate methods
    create: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function create() {
        return _create.apply(this, arguments);
      }

      return create;
    }(),
    cancelCreate: function cancelCreate() {},
    check: function check() {
      return false;
    },
    cancelCheck: function cancelCheck() {},
    // CanUpdate methods
    update: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function update() {
        return _update.apply(this, arguments);
      }

      return update;
    }(),
    cancelUpdate: function cancelUpdate() {},
    // CanRemove methods
    remove: function remove() {},
    cancelRemove: function cancelRemove() {},
    // CanRefreshList methods
    refresh: function refresh() {},
    cancelRefresh: function cancelRefresh() {}
  };
};

/**
 * ## The Sector Resource Hook
 * 
 * #### - Getting List of Resources:
 * ```
 * const state = useNews() as ListNewsState;
 * ```
 * 
 * #### Getting Single Resource:
 * ```
 * const state = useNews(newsId) as SingleNewState;
 * // to update the data
 * state.update(newsId, data);
 * // to delete the data
 * state.remove(newsId);
 * ```
 * 
 * #### Getting Empty Resource:
 * ```javascript
 * const state = useNews(null) as EmptySectorState;
 * // to create a new data
 * state.create(data);
 * ```
 * 
 */

var useNews = resourceHookFactory('content/news');

var useLicenses = resourceHookFactory('content/licenses');

var methodPathOverride$8 = {
  HEAD: 'slug/availability',
  PUBLISH: '/publish',
  UNPUBLISH: ''
};
/**
 * The Media API endpoint.
 */

/**
 * ## The Media Resource Hook
 * 
 * #### - Getting List of Resources:
 * ```
 * const state = useMedia() as ListMediaState;
 * ```
 * 
 * #### - Passing Dependency List and Options.
 * ```
 * const [tagFilters, setTagFilters] = useState([]);
 * // add tagFilters to the useMedia' internal useEffect dependency list
 * const state = useMedia([tagFilters], { setParams }) as ListMediaState;
 * // callback function to set the query parameters
 * function setParams() {
 *    return {
 *      tags: tagFilters.map(tag => tag.id)
 *    };
 * }
 * ```
 * 
 * #### Getting Single Resource:
 * ```
 * const state = useMedia(faqId) as SingleMediaState;
 * // to update the data
 * state.update(faqId, data);
 * // to delete the data
 * state.remove(faqId);
 * ```
 * 
 * #### Getting Empty Resource:
 * ```javascript
 * const state = useMedia(null) as EmptyMediaState;
 * // to create a new data
 * state.create(data);
 * ```
 * 
 */

var useMedia = resourceHookFactory('bht/author/media', methodPathOverride$8);

var _MEDIATYPES;
var MEDIATYPES = (_MEDIATYPES = {}, _defineProperty(_MEDIATYPES, Language.ENGLISH, [{
  key: "VIDEO",
  value: "VIDEO",
  text: "Video"
}, {
  key: "WEBINAR",
  value: "WEBINAR",
  text: "Webinar"
}]), _defineProperty(_MEDIATYPES, Language.NORWEGIAN, [{
  key: "VIDEO",
  value: "VIDEO",
  text: "Video"
}, {
  key: "WEBINAR",
  value: "WEBINAR",
  text: "Webinar"
}]), _defineProperty(_MEDIATYPES, Language.POLISH, [{
  key: "VIDEO",
  value: "VIDEO",
  text: "Wideo"
}, {
  key: "WEBINAR",
  value: "WEBINAR",
  text: "Webinar"
}]), _defineProperty(_MEDIATYPES, Language.LITHUANIAN, [{
  key: "VIDEO",
  value: "VIDEO",
  text: "Vaizdo įrašas"
}, {
  key: "WEBINAR",
  value: "WEBINAR",
  text: "Tinklalaidė"
}]), _MEDIATYPES);

/**
 * ## The Media Types Resource Hook
 * 
 * #### Getting the media types dropdown values
 * ```javascript
 * import {
 *  KeyValueText,
 *  Language,
 *  useMediaTypes,
 * } from '@lyonfuture/api';
 *
 * const mediaTypes = useMediaTypes(Language.ENGLISH).data as KeyValueText[];
 * ```
 */

var useMediaTypes = function useMediaTypes(language) {
  var _useListStateReducer = useListStateReducer(),
      _useListStateReducer2 = _slicedToArray(_useListStateReducer, 2),
      listState = _useListStateReducer2[0],
      listDispatch = _useListStateReducer2[1];

  useEffect(function () {
    listDispatch({
      type: 'success',
      data: MEDIATYPES[language]
    });
  }, [language]);
  return listState;
};

var methodPathOverride$9 = {
  'HEAD': 'slug',
  'PUBLISH': '',
  'UNPUBLISH': ''
};
/**
 * ## The MediaSeries Resource Hook
 * 
 * #### - Getting List of Resources:
 * ```
 * const state = useMediaSeries() as ListMediaSeriesState;
 * ```
 * 
 * #### - Passing Dependency List and Options.
 * ```
 * const [tagFilters, setTagFilters] = useState([]);
 * // add tagFilters to the useMediaSeries' internal useEffect dependency list
 * const state = useMediaSeries([tagFilters], { setParams }) as ListMediaSeriesState;
 * // callback function to set the query parameters
 * function setParams() {
 *    return {
 *      tags: tagFilters.map(tag => tag.id)
 *    };
 * }
 * ```
 * 
 * #### Getting Single Resource:
 * ```
 * const state = useMediaSeries(id) as SingleMediaSeriesState;
 * // to update the data
 * state.update(id, data);
 * // to delete the data
 * state.remove(id);
 * ```
 * 
 * #### Getting Empty Resource:
 * ```javascript
 * const state = useMediaSeries(null) as EmptyMediaSeriesState;
 * // to create a new data
 * state.create(data);
 * ```
 * 
 */

var useMediaSeries = resourceHookFactory('content/mediaseries', methodPathOverride$9);

var FAGBANK_LEDER = 'PRODUCT-2';
var FAGBANK_ANSATT = 'PRODUCT-3';
var BHT = 'PRODUCT-5';
var PUBLIC = 'PRODUCT-99';
var PRODUCTS = [{
  "productId": {
    "id": "PRODUCT-1"
  },
  "name": "HMS System",
  "description": "Fullstendig HMS system",
  "createdDate": "2020-11-06T00:00",
  "modifiedDate": "2020-11-06T00:00"
}, {
  "productId": {
    "id": "PRODUCT-2"
  },
  "name": "Fagbank leder",
  "description": "Produkt fagbank leder",
  "createdDate": "2020-11-06T00:00",
  "modifiedDate": "2020-11-06T00:00"
}, {
  "productId": {
    "id": "PRODUCT-3"
  },
  "name": "Fagbank ansatt",
  "description": "Produkt fagbank ansatt",
  "createdDate": "2020-11-06T00:00",
  "modifiedDate": "2020-11-06T00:00"
}, {
  "productId": {
    "id": "PRODUCT-4"
  },
  "name": "SINGEL ACCESS",
  "description": "Enkel aksess",
  "createdDate": "2021-02-15T00:00",
  "modifiedDate": "2021-02-15T00:00"
}, {
  "productId": {
    "id": "PRODUCT-5"
  },
  "name": "Digital BHT",
  "description": "Digital BHT",
  "createdDate": "2023-07-04T00:00",
  "modifiedDate": "2023-07-04T00:00"
}, {
  "productId": {
    "id": "PRODUCT-6"
  },
  "name": "HR system",
  "description": "HR system",
  "createdDate": "2023-07-04T00:00",
  "modifiedDate": "2023-07-04T00:00"
}, {
  "productId": {
    "id": "PRODUCT-7"
  },
  "name": "Kursportal Fagbank",
  "description": "Kursportal Fagbank",
  "createdDate": "2023-07-04T00:00",
  "modifiedDate": "2023-07-04T00:00"
}, {
  "productId": {
    "id": "PRODUCT-8"
  },
  "name": "Free trial HMS-kurs for leder",
  "description": "Free trial HMS-kurs for leder",
  "createdDate": "2024-06-06T00:00",
  "modifiedDate": "2024-06-06T00:00"
}, {
  "productId": {
    "id": "PRODUCT-9"
  },
  "name": "HR og kurs",
  "description": "HR og HR spesifikke kurs",
  "createdDate": "2025-03-26T00:00",
  "modifiedDate": "2025-03-26T00:00"
}, {
  "productId": {
    "id": "PRODUCT-99"
  },
  "name": "Public (Åpnen for alle)",
  "description": "Åpen for alle",
  "createdDate": "2020-11-27T00:00",
  "modifiedDate": "2020-11-27T00:00"
}, {
  "productId": {
    "id": "PRODUCT-GJI"
  },
  "name": "Gronn jobb internal",
  "description": "Limited access to only gronn jobb employees",
  "createdDate": "2023-06-12T00:00",
  "modifiedDate": "2023-06-12T00:00"
}];

// export const useProducts = resourceHookFactory<ProductObj, ListProductsState, SingleProductState, EmptyProductState, PageProductsState>('content/products');
//Handcoded for now
var useProducts = function useProducts() {
  return {
    data: PRODUCTS,
    fetched: true,
    saved: false,
    deleted: false,
    isLoading: false,
    isSaving: false,
    isDeleting: false,
    isCreating: false,
    created: false,
    error: null
  };
};

var useTranslateExams = resourceHookFactory('exam/editor/exam-translations');

var methodPathOverride$a = {
  POST: 'create'
};
/**
 * ## The Tag Resource Hook
 * 
 * #### - Getting List of Resources:
 * ```
 * const state = useTags() as ListTagsState;
 * ```
 * 
 * #### - Passing Dependency List and Options.
 * ```
 * const [tagFilters, setTagFilters] = useState([]);
 * // add tagFilters to the useTag' internal useEffect dependency list
 * const state = useTags([tagFilters], { setParams }) as ListTagsState;
 * // callback function to set the query parameters
 * function setParams() {
 *    return {
 *      tags: tagFilters.map(tag => tag.id)
 *    };
 * }
 * ```
 * 
 * #### Getting Single Resource:
 * ```
 * const state = useTags(faqId) as SingleTagState;
 * // to update the data
 * state.update(faqId, data);
 * // to delete the data
 * state.remove(faqId);
 * ```
 * 
 * #### Getting Empty Resource:
 * ```javascript
 * const state = useTags(null) as EmptyTagState;
 * // to create a new data
 * state.create(data);
 * ```
 * 
 */

var useTags = resourceHookFactory('bht/author/media/tags', methodPathOverride$a);

/**
 * ## The CourseTag Resource Hook
 * 
 * #### - Getting List of Resources:
 * ```
 * const state = useCourseTags() as ListCourseTagsState;
 * ```
 * 
 * #### - Passing Dependency List and Options.
 * ```
 * const [courseTagFilters, setCourseTagFilters] = useState([]);
 * // add tagFilters to the useTag' internal useEffect dependency list
 * const state = useCourseTags([courseTagFilters], { setParams }) as ListCourseTagsState;
 * // callback function to set the query parameters
 * function setParams() {
 *    return {
 *      tags: courseTagFilters.map(tag => tag.id)
 *    };
 * }
 * ```
 * 
 * #### Getting Single Resource:
 * ```
 * const state = useCourseTags(courseTagId) as SingleCourseTagState;
 * // to update the data
 * state.update(courseTagId, data);
 * // to delete the data
 * state.remove(courseTagId);
 * ```
 * 
 * #### Getting Empty Resource:
 * ```javascript
 * const state = useCourseTags(null) as EmptyCourseTagState;
 * // to create a new data
 * state.create(data);
 * ```
 *  
 */

var useCourseTags = resourceHookFactory('exam/editor/tags');

var useUsers = resourceHookFactory('content/user');

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var UsersContext = createContext({
  data: null,
  isLoading: false,
  fetched: false,
  error: null
});
var UsersProvider = function UsersProvider(_ref) {
  var children = _ref.children,
      accountId = _ref.accountId,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? 1 : _ref$page,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 5 : _ref$size,
      search = _ref.search;
  var path = accountId ? "content/accounts/".concat(accountId, "/users") : 'content/user';

  var _useGetAsync = useGetAsync(path),
      _useGetAsync2 = _slicedToArray(_useGetAsync, 2),
      getUsersAsync = _useGetAsync2[0],
      cancelGet = _useGetAsync2[1];

  var _usePageStateReducer = usePageStateReducer(),
      _usePageStateReducer2 = _slicedToArray(_usePageStateReducer, 2),
      pageState = _usePageStateReducer2[0],
      pageDispatch = _usePageStateReducer2[1];

  useEffect(function () {
    getUsersAsync('', {
      params: {
        page: page,
        size: size,
        search: search
      }
    }, pageDispatch);
    return function () {
      cancelGet();
    };
  }, [page, size, search]);
  return /*#__PURE__*/React.createElement(UsersContext.Provider, {
    value: _objectSpread$5({}, pageState)
  }, children);
};

var useQuiz = resourceHookFactory('exam/editor/quiz');

var useQuizQuestions = resourceHookFactory('exam/editor/quiz/question');

var useVideoQuiz = resourceHookFactory('exam/editor/quiz/course-video');

var getCategoryValue = function getCategoryValue(category) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Language.NORWEGIAN;
  return CATEGORIES_LANGUAGE_MAP[category][language];
};

/**
 * Returns `true` if the value is an IdBase-like object.
 * That is, an object with a property `id` of type string
 * and is not empty.
 */
var isIdBaseLike = function isIdBaseLike(value) {
  return value && _typeof(value) === 'object' && typeof value.id === 'string' && value.id;
};

/**
 * Util function for slugifying a string.
 * 
 * @param string string to be slugifies
 * @returns slugified string or undefined
 */
var slugify = function slugify(string) {
  if (_typeof(string) === undefined || !string) return '';
  var a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
  var b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
  var p = new RegExp(a.split('').join('|'), 'g');
  return string.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
  .replace(p, function (c) {
    return b.charAt(a.indexOf(c));
  }) // Replace special characters
  .replace(/&/g, '-and-') // Replace & with 'and'
  .replace(/[^\w-]+/g, '') // Remove all non-word characters
  .replace(/--+/g, '-') // Replace multiple - with single -
  .replace(/^-+/, '') // Trim - from start of text
  .replace(/-+$/, ''); // Trim - from end of text
};

/**
 * Returns `true` if the value is an TranslatedText-like object.
 * That is, an object with a property `content` of type string
 * and proptery `language` of type string, and is not empty.
 */
var isTranslatedTextLike = function isTranslatedTextLike(value) {
  return value && _typeof(value) === 'object' && 'language' in value && typeof value.content === 'string' && value.content;
};

/**
 * 
 * ```
 * import {
 *  KeyValueText,
 *  toKeyValueText,
 *  useTags,
 * } from '@lyonfuture/api';
 * 
 * const tagsState = useTags() as ListTagsState;
 * const tagOptions = tagsState.data
 *  ? (toKeyValueText(
 *    tagsState.data as Tag[],
 *    'id',
 *    'id',
 *    'name',
 *  ) as DropdownOption[])
 *  : [];
 * ```
 * @param data Any object 
 * @param keyProp Must be a property of data. 
 * If the value is an IdBase, the `key` will be set to the value of its `id`.
 * @param valueProp Must be a property of data. 
 * If the value is an IdBase, the `key` will be set to the value of its `id`.
 * @param textProp Must be a property of data.
 */
function toKeyValueText(data, keyProp, valueProp, textProp) {
  if (Array.isArray(data)) {
    return data.map(function (d) {
      return toKeyValueText(d, keyProp, valueProp, textProp);
    });
  } else if (data && _typeof(data) === 'object') {
    var key = '';
    var value = '';
    var text = '';

    if (isIdBaseLike(data[keyProp])) {
      key = data[keyProp].id;
    } else if (typeof data[keyProp] === 'string') {
      key = "".concat(data[keyProp]);
    }

    if (isIdBaseLike(data[valueProp])) {
      value = data[valueProp].id;
    } else if (typeof data[valueProp] === 'string') {
      value = "".concat(data[valueProp]);
    }

    if (isTranslatedTextLike(data[textProp])) {
      text = data[textProp].content;
    } else if (typeof data[textProp] === 'string') {
      text = "".concat(data[textProp]);
    }

    return {
      key: key,
      value: value,
      text: text
    };
  } else {
    console.error('[toKeyValueText] Invalid data:', data);
    return null;
  }
}

var APIProvider = function APIProvider(_ref) {
  var children = _ref.children,
      config = _ref.config,
      httpRequestInterceptor = _ref.httpRequestInterceptor;
  var axiosInstance = useMemo(function () {
    var instance = Axios.create(config);

    if (httpRequestInterceptor) {
      instance.interceptors.request.use(httpRequestInterceptor);
    }
    /*
      Uncomment the code below if you're running the backend in localhost.
      Set API_BASE_URL=http://localhost:8080/api/1.0/ in .env.development,
      and uncomment the proxy config in webpack.development.config.js
    */
    // instance.interceptors.request.use((config: AxiosRequestConfig): AxiosRequestConfig => {
    //   config.url = config.url ? config.url.replace('content/', '') : '';
    //   return config;
    // });


    return instance;
  }, [config, httpRequestInterceptor]);
  return /*#__PURE__*/React.createElement(APIContext.Provider, {
    value: {
      axiosInstance: axiosInstance
    }
  }, children);
};

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useFetcher = function useFetcher(url, config) {
  var _useLazyFetcher = useLazyFetcher(url, config),
      _useLazyFetcher2 = _slicedToArray(_useLazyFetcher, 2),
      fetch = _useLazyFetcher2[0],
      result = _useLazyFetcher2[1];

  useEffect(function () {
    var cancelToken = Axios.CancelToken.source();

    var actualConfig = _objectSpread$6(_objectSpread$6({
      method: 'GET',
      cancelToken: cancelToken.token
    }, typeof url === 'string' ? {} : url), _typeof(config) === 'object' ? config : {});

    if (typeof url === 'string') {
      actualConfig.url = url;
    }

    fetch(actualConfig)["catch"](function () {});
    return function () {
      cancelToken.cancel();
    };
  }, [url, config]);
  return result;
};
var useLazyFetcher = function useLazyFetcher(url, config) {
  var http = useHttp();

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      called = _useState8[0],
      setCalled = _useState8[1];

  var defaultUrl = url;
  var defaultConfig = config;

  var fetch = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var url,
          config,
          actualConfig,
          _response,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = _args.length > 0 && _args[0] !== undefined ? _args[0] : defaultUrl;
              config = _args.length > 1 && _args[1] !== undefined ? _args[1] : defaultConfig;
              actualConfig = _objectSpread$6(_objectSpread$6({
                method: 'GET'
              }, typeof url === 'string' ? {
                url: url
              } : url), _typeof(config) === 'object' ? config : {});
              setCalled(true);
              setLoading(true);
              _context.prev = 5;
              _context.next = 8;
              return http.request(actualConfig);

            case 8:
              _response = _context.sent;
              setLoading(false);
              setData(_response.data);
              setError(undefined);
              return _context.abrupt("return", _response.data);

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](5);
              setError(_context.t0);
              setLoading(false);
              throw _context.t0;

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 15]]);
    }));

    return function fetch() {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchMore = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options) {
      var updateResult, optionsAxiosRequestConfig, actualConfig, _response2;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              updateResult = options.updateResult, optionsAxiosRequestConfig = _objectWithoutProperties(options, ["updateResult"]);
              actualConfig = _objectSpread$6(_objectSpread$6(_objectSpread$6({
                method: 'GET'
              }, typeof defaultUrl === 'string' ? {
                url: defaultUrl
              } : defaultUrl), _typeof(defaultConfig) === 'object' ? defaultConfig : {}), optionsAxiosRequestConfig);
              setCalled(true);
              setLoading(true);
              _context2.prev = 4;
              _context2.next = 7;
              return http.request(actualConfig);

            case 7:
              _response2 = _context2.sent;
              setLoading(false);
              return _context2.abrupt("return", new Promise(function (resolve) {
                setData(function (prev) {
                  var result = options.updateResult(prev, _response2);
                  resolve(result);
                  return result;
                });
              }));

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](4);
              setError(_context2.t0);
              setLoading(false);
              throw _context2.t0;

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 12]]);
    }));

    return function fetchMore(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [fetch, {
    data: data,
    loading: loading,
    error: error,
    called: called,
    fetchMore: fetchMore,
    refetch: fetch
  }];
};
var useMutation = function useMutation(url, config) {
  var http = useHttp();

  var _useState9 = useState(undefined),
      _useState10 = _slicedToArray(_useState9, 2),
      data = _useState10[0],
      setData = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      loading = _useState12[0],
      setLoading = _useState12[1];

  var _useState13 = useState(undefined),
      _useState14 = _slicedToArray(_useState13, 2),
      error = _useState14[0],
      setError = _useState14[1];

  var defaultUrl = url;
  var defaultConfig = config;

  var mutate = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data, config) {
      var actualConfig, _response3;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              actualConfig = _objectSpread$6(_objectSpread$6({
                method: 'POST',
                data: data
              }, _typeof(defaultConfig) === 'object' ? defaultConfig : {}), _typeof(config) === 'object' ? config : {});

              if (typeof defaultUrl === 'string' && !(config === null || config === void 0 ? void 0 : config.url)) {
                actualConfig.url = defaultUrl;
              }

              setLoading(true);
              _context3.prev = 3;
              _context3.next = 6;
              return http.request(actualConfig);

            case 6:
              _response3 = _context3.sent;
              setLoading(false);
              setData(_response3.data);
              return _context3.abrupt("return", _response3.data);

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](3);
              setError(_context3.t0);
              setLoading(false);
              throw _context3.t0;

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 12]]);
    }));

    return function mutate(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  return [mutate, {
    data: data,
    loading: loading,
    error: error
  }];
};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useFileUpload = function useFileUpload(url, config) {
  var _useMutation = useMutation(url, config),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      result = _useMutation2[1];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      uploading = _useState2[0],
      setUploading = _useState2[1];

  var upload = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var meta, other, metaResponse, formData, _key;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              meta = _ref.meta, other = _objectWithoutProperties(_ref, ["meta"]);
              setUploading(true);
              _context.next = 4;
              return mutate(meta);

            case 4:
              metaResponse = _context.sent;
              formData = new FormData();
              _context.t0 = _regeneratorRuntime.keys(other);

            case 7:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 15;
                break;
              }

              _key = _context.t1.value;

              if (!(_key === 'fileName')) {
                _context.next = 12;
                break;
              }

              // @ts-ignore
              formData.set(_key, "".concat(metaResponse.id.id, "_").concat(other[_key]));
              return _context.abrupt("continue", 7);

            case 12:
              formData.set(_key, other[_key]);
              _context.next = 7;
              break;

            case 15:
              return _context.abrupt("return", mutate(formData, {
                // @ts-ignore
                url: "".concat(url, "/").concat(metaResponse.id.id, "/upload"),
                method: 'PUT'
              }).then(function (response) {
                setUploading(false);
                return response;
              }));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function upload(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [upload, _objectSpread$7(_objectSpread$7({}, result), {}, {
    loading: uploading
  })];
};

export { APIProvider, BHT, COURSE_TYPES, Category, CourseCategory, CourseFagbankCategory, CourseType, DOCUMENT_TYPES_LANGUAGE_MAP, DocumentType, EventType, FAGBANK_ANSATT, FAGBANK_LEDER, Language, LanguageCode, MediaType, PRODUCTS, PUBLIC, SubscriptionTypeEnum, UsersContext, UsersProvider, XpandProduct, base64encode, getCategoryValue, isIdBaseLike, slugify, toKeyValueText, useAccounts, useArticles, useAttachmentGroups, useAttachments, useAuthors, useBhtDocuments, useCategories, useCourse, useCourseAuthors, useCourseTags, useDeleteAsync, useDiplomaTemplates, useDiplomas, useEmptyStateReducer, useEvents, useExamQuestions, useExams, useFaqs, useFetcher, useFileUpload, useFreeTextQuestions, useGetAsync, useHeadAsync, useImages, useIndustries, useLazyFetcher, useLicenses, useListStateReducer, useMedia, useMediaSeries, useMediaTypes, useMutation, useNews, usePageStateReducer, usePositions, usePostAsync, useProducts, usePutAsync, useQuiz, useQuizQuestions, useSectors, useSingleStateReducer, useTags, useTranslateExams, useUsers, useVideoQuiz };
